import { useEffect, useState } from 'react';
import { getImageUrl, getStudentPhotoUrl, getCompanyLogoUrl } from '../utils/imageUtils';
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import Select from "react-select";


export default function BillList() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [tasksAll, setTasksAll] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [selectedStatus, setsselectedStatus] = useState();
    const [showModal, setShowModal] = useState(false);
    const [showModalAll, setShowModalall] = useState(false);
    const [showModalOnce, setShowModalOce] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [editUserUpdate, setEditUserUpdate] = useState({});
    const [editUserEdit, setEditUserEdit] = useState({});
    const [cat, setCat] = useState([]);
    const [masterdata, setmasterdata] = useState([]);
    const [masterdataIndi, setMasterdataIndi] = useState([]);
    const [tasksind, setTasksInd] = useState([]);
    const [editColumn, setEditColumn] = useState(null);
    const [users, setUsers] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [bulkData, setBulkData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalSum, setTotalSum] = useState('');
    const { id } = useParams();
    const [paymentInProgress, setPaymentInProgress] = useState(false);
    const [isAmountValidPay, setIsAmountValidPay] = useState(false);
    const [isAmountValidPayEdit, setIsAmountValidPayEdit] = useState(false);
    const [isAmountValidPayNag, setIsAmountValidPayNag] = useState(false);
    const [isTrigger, setIsisTrigger] = useState(false);
    const [isTriggerEdit, setIsisTriggerEdit] = useState(false);
    const [selectedFees, setSelectedFees] = useState([]);
    const [currentDate, setCurrentDate] = useState('');
    const [currentDates, setCurrentDates] = useState('');
    const [annualIds, setAnnualIds] = useState([]);
    const [minDate, setMinDate] = useState('');
    const [handleDate, handleChangeDate] = useState('');
    const [agent, setAgent] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalPaid, setTotalPaid] = useState(0);
    const [totalDue, setTotalDue] = useState(0);
    const [showPrintPreview, setShowPrintPreview] = useState(false);
    const [showNdcPreview, setShowNdcPreview] = useState(false);
    const [companyname, setCompanyname] = useState('');
    const [companylogo, setCompanylogo] = useState('');
    const [companyaddr, setCompanyaddr] = useState('');
    const [showPaymentHistoryModal, setShowPaymentHistoryModal] = useState(false);
    const [selectedPaymentHistory, setSelectedPaymentHistory] = useState([]);
    const [selectedFeeInfo, setSelectedFeeInfo] = useState({});
    const [showPaymentDetailsTable, setShowPaymentDetailsTable] = useState(false);
    const [showDetailedSummaryModal, setShowDetailedSummaryModal] = useState(false);
    
    const [utrWarning, setUtrWarning] = useState("");
    const [utrWarningBulk, setUtrWarningBulk] = useState("");
    const [selectedYear, setSelectedYear] = useState("all");

    // Individual payment edit modal state
    const [showEditPaymentModal, setShowEditPaymentModal] = useState(false);
    const [editingPayment, setEditingPayment] = useState(null);
    const [editPaymentData, setEditPaymentData] = useState({
        amount: '',
        ext_1: '', // Payment method
        ext_2: '', // Reference number
        alt_date: '',
        agent_id: '' // Agent ID if payment method is Agent
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await http.get(`/student_marks?&id=${id}&company_id=${user.company_id}`);
                setTimeout(() => {
                    setStudents(response.data.data);
                    setLoading(false); // Set loading to false after setting the state
                }, 200); // 20 seconds in milliseconds
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false); // Set loading to false in case of an error
            }

            try {
                const response = await http.get(`/bulk_print?&user=${id}`);
                setTimeout(() => {
                    setTasksAll(response.data.data);
                }, 200); // 20 seconds in milliseconds
            } catch (error) {
                console.error("Error bulk print files:", error);
            }

            http.get(`/agent?login_user=${user.id}&company_id=${user.company_id}`).then((res) => {
                setAgent(res.data.data);
            });

            await http.get(`/companyinfo?login_user=${user.id}`).then((resp) => {
                setCompanyname(resp.data.data[0].company_name);
                setCompanylogo(resp.data.data[0].company_logo);
                setCompanyaddr(resp.data.data[0].company_address);
            });
        };
        fetchData();
        fetchTaskDetails();

        const today = new Date().toISOString().split('T')[0];
        setCurrentDate(today);
        setCurrentDates(today);
        setMinDate(today);
    }, [id]);

    // Get unique years from tasks and set default to latest
    const availableYears = [...new Set(tasks.map(t => t.fees_name?.ext_2).filter(Boolean))].sort().reverse();

    useEffect(() => {
        if (tasks && tasks.length > 0 && selectedYear === "all" && availableYears.length > 0) {
            setSelectedYear(availableYears[0]);
        }
    }, [tasks]);

    // Current academic year = latest year tab (same as default selection).
    // Only on that tab: also show older years that still have due > 0.
    // Older year tabs: that year only (never pull in newer years).
    // "All": everything.
    const currentAcademicYear = availableYears[0] || null;
    const filteredTasks =
        selectedYear === "all"
            ? tasks
            : tasks.filter((t) => {
                const year = t.fees_name?.ext_2;
                if (year === selectedYear) {
                    return true;
                }
                // Carry forward unpaid older fees only when viewing the current year tab
                if (
                    selectedYear === currentAcademicYear &&
                    year &&
                    year < selectedYear
                ) {
                    const due =
                        (parseFloat(t.amount) || 0) - (parseFloat(t.ext_6) || 0);
                    return due > 0;
                }
                return false;
            });

    //Add this useEffect to calculate totals when tasks or year filter change
    useEffect(() => {
        if (filteredTasks && filteredTasks.length > 0) {
            const amountSum = filteredTasks.reduce((sum, task) => sum + (parseFloat(task.amount) || 0), 0);
            const paidSum = filteredTasks.reduce((sum, task) => sum + (parseFloat(task.ext_6) || 0), 0);
            const dueSum = amountSum - paidSum;

            setTotalAmount(amountSum);
            setTotalPaid(paidSum);
            setTotalDue(dueSum);
        } else {
            setTotalAmount(0);
            setTotalPaid(0);
            setTotalDue(0);
        }
    }, [tasks, selectedYear]);

    //After fetch update calling this
    const fetchDataBulkAfterUpdate = async () => {
        try {
            const response = await http.get(`/bulk_print?&user=${id}`);
            setTimeout(() => {
                setTasksAll(response.data.data);
            }, 200); // 20 seconds in milliseconds
        } catch (error) {
            console.error("Error bulk print files:", error);
        }
    };


    const fetchTaskDetails = (
    ) => {
        setIsLoading(true);
        let endpoint = `/feeslist?student_id=${id}`;
        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);

                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });

    };

    const [formData2, setFormData2] = useState({
        ext_1: '',
        student_id: '',
        first_name: '',
        last_name: '',
        amount: '',
        class: '',
        dev: '',
        adm_no: '',
        type: '',
        reference: '',
        ext_4: '',
        trig_date_club: currentDates,
        user_id: user.id,
    });


    const handleSave = async (taskId) => {
        if (currentStatus === null || taskId === null) {
            toast.error("Please select proper status");
            return true;
        }
        try {
            const response = await http.put(
                `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
                    currentStatus
                )}`
            );
            toast.success("Task status updated successfully !");
            fetchTaskDetails();
        } catch (error) {
            console.error("Error fetching tasks:", error);
            toast.error("Please select proper item");
        }
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
        if (e.target.name === "category") {
            fetchUsersForDepartment(e.target.value);
        }
        if (e.target.name === "master_id") {
            fetchMasterIndividual(e.target.value);
        }

        if (e.target.name === "ext_2") {
            setIsAmountValidPay(parseFloat(e.target.value) > parseFloat(isTrigger) ? true : false);
        }

        if (e.target.name === "ext_2") {
            setIsAmountValidPayEdit(parseFloat(e.target.value) > parseFloat(isTriggerEdit) ? true : false);
        }

        if (e.target.name === "ext_2") {
            setIsAmountValidPayNag(parseFloat(e.target.value) < 0 ? true : false);
        }

    };

    const handleChangeModalOnce = (e) => {
        setFormData2({
            ...formData2,
            [e.target.name]: e.target.value,
        });
    };

    const checkUtrDuplicate = async (refValue, setter) => {
        if (!refValue || refValue.length < 4) {
            setter("");
            return;
        }
        if (!refValue.trim().toLowerCase().startsWith("utr")) {
            setter("");
            return;
        }
        try {
            const res = await http.get(`/check_utr_duplicate?reff=${encodeURIComponent(refValue.trim())}&company_id=${user.company_id}`);
            if (res.data.duplicate) {
                setter("This Ref No already exists! Please verify before proceeding.");
            } else {
                setter("");
            }
        } catch (err) {
            console.error("UTR check error:", err);
            setter("");
        }
    };

    const handleChangeModalEdit = (e) => {
        setFormData4({
            ...formData4,
            [e.target.name]: e.target.value,
        });

        if (e.target.name === "ext_2") {
            setIsAmountValidPay(parseFloat(e.target.value) > parseFloat(isTrigger) ? true : false);
        }

        if (e.target.name === "ext_2") {
            setIsAmountValidPayEdit(parseFloat(e.target.value) > parseFloat(isTriggerEdit) ? true : false);
        }

        if (e.target.name === "ext_2") {
            setIsAmountValidPayNag(parseFloat(e.target.value) < 0 ? true : false);
        }

    };

    const fetchUsersForDepartment = async (departmentId) => {
        try {
            const response = await http.get(`/master_cat?cat=${departmentId}`);
            setmasterdata(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const [formData1, setFormData1] = useState({
        student_id: "",
        fees_id: "",
        first_name: "",
        last_name: "",
        amount: "",
        class: "",
        dev: "",
        adm_no: "",
        type: "",
        reference: "",
        amount: "",
        mode: "",
        ext_7: "",
        user_id: user.id,
        trig_date: currentDate,
        company_id: user.company_id,
        agent_id: ""
    });

    const [formData4, setFormData4] = useState({
        student_id: "",
        fees_id: "",
        first_name: "",
        last_name: "",
        amount: "",
        class: "",
        dev: "",
        adm_no: "",
        type: "",
        reference: "",
        amount: "",
        method: "",
        ext_7: "",
        ext_2: "",
        user_id: user.id,
        reff: "",
        date: "",
        agent_id: ""
    });


    const openEditModal = async (taskAll, index) => {
        setIsisTrigger(taskAll.amount - taskAll.ext_6 || "");
        setIsisTriggerEdit(taskAll.amount || "");
        setEditColumn(index);
        setShowModal(true);
        setFormData1({
            name: taskAll.tution_fees.name || "",
            ext_1: taskAll.tution_fees.ext_2 || "",
            ext_2: taskAll.amount - taskAll.ext_6 || "",
            reff: "",
            student_id: taskAll.student_id || "",
            method: taskAll.method || "",
            fees_id: taskAll.fees_id || "",
            first_name: taskAll.first_name || "",
            last_name: taskAll.last_name || "",
            class: taskAll.class || "",
            dev: taskAll.dev || "",
            adm_no: taskAll.admn_no || "",
            ext_7: taskAll.ext_3 || "",
            user_id: user.id || "",
            company_id: user.company_id || "",
            agent_id: ""
        });
        setEditUser(taskAll);
    };

    const openEditModalUpdate = async (taskAll, index) => {
        try {
            const res = await http.get(`/is_bulk?id=${taskAll.id}`);
            const bulkData = res.data.data;
            setBulkData(bulkData);

            const annualIds = bulkData.map(data => data.annual_id);
            setAnnualIds(annualIds);
            const lastPaidFee = taskAll.related_paid_fee_all.length > 0 ? taskAll.related_paid_fee_all[taskAll.related_paid_fee_all.length - 1] : null; // Check if array is not empty

            setIsisTrigger(taskAll.amount - taskAll.ext_6 || "");
            setIsisTriggerEdit(taskAll.amount || "");
            setEditColumn(index);
            setFormData4({
                name: taskAll.tution_fees.name || "",
                ext_1: taskAll.tution_fees.ext_2 || "",
                ext_2: lastPaidFee ? lastPaidFee.amount : "",
                reff: taskAll && taskAll.related_paid_fee ? taskAll.related_paid_fee.ext_2 || "" : "",
                student_id: user.id || "",
                method: taskAll && taskAll.related_paid_fee ? taskAll.related_paid_fee.ext_1 || "" : "",
                fees_id: taskAll.fees_id || "",
                first_name: taskAll.first_name || "",
                last_name: taskAll.last_name || "",
                class: taskAll.class || "",
                dev: taskAll.dev || "",
                adm_no: taskAll.admn_no || "",
                ext_7: taskAll.ext_3 || "",
                user_id: user.id || "",
                agent_id: taskAll.related_paid_fee.agent_id ? taskAll.related_paid_fee.agent_id || "" : "",
                date: taskAll && taskAll.related_paid_fee
                    ? taskAll.related_paid_fee.alt_date || taskAll.related_paid_fee.created_at || ""
                    : ""
            });

            if (bulkData && Object.keys(bulkData).length > 0) {
                setShowModalall(true);
            } else {
                setShowModalEdit(true);
            }

            setIsAmountValidPay("");
            setIsAmountValidPayNag("");
            setEditUserUpdate(taskAll);
        } catch (error) {
            console.error('Error fetching bulk data:', error);
            // Handle error appropriately
        }
    };


    const openEditModalUpdateOnce = async (taskAll, index) => {
        try {
            setEditColumn(index);
            setFormData4({
                name: taskAll.tution_fees.name || "",
                ext_1: taskAll.tution_fees.ext_2 || "",
                ext_2: taskAll.ext_6 || "",
                reff: taskAll.related_paid_fee.ext_2 || "",
                student_id: user.id || "",
                method: taskAll.related_paid_fee.ext_1 || "",
                fees_id: taskAll.fees_id || "",
                first_name: taskAll.first_name || "",
                last_name: taskAll.last_name || "",
                class: taskAll.class || "",
                dev: taskAll.dev || "",
                adm_no: taskAll.admn_no || "",
                ext_7: taskAll.ext_3 || "",
                user_id: user.id || "",

            });
            setShowModalEdit(true);
            setIsAmountValidPay("");
            setIsAmountValidPayNag("");
            setEditUserUpdate(taskAll);
        } catch (error) {
            setIsAmountValidPay("");
            setIsAmountValidPayNag("");
            console.error('Error fetching bulk data:', error);
            // Handle error appropriately
        }
    };


    const openEditModalOnce = async () => {
        setTotalSum("");
        setShowModalOce(true);
        try {
            const response = await http.get(`/get_pay_fees?&login_user=${user.id}&ids=${selectedItems}`);
            const total = response.data.data.total;
            // Check if total is retrieved correctly
            setTotalSum(total);
            setLoading(false); // Set loading to false after setting the state
        } catch (error) {
            setIsAmountValidPay("");
            setIsAmountValidPayNag("");
            console.error("Error fetching total:", error);
        }

        if (students.length > 0) {
            let totalSumAll = '';
            try {
                const response = await http.get(`/get_pay_fees?&login_user=${user.id}&ids=${selectedItems}`);
                totalSumAll = response.data.data.total;
            } catch (error) {
                console.error("Error fetching total:", error);
            }

            const student = students[0];
            const selectedItemsString = selectedItems.join(',');
            const formData = {
                ext_1: selectedItemsString,
                ext_4: student.photo,
                student_id: student.id,
                first_name: student.ext_2,
                last_name: student.ext_3,
                amount: totalSumAll,
                class: student.class,
                dev: student.section,
                adm_no: student.adm_no,
                type: formData2.type || "",
                reference: formData2.reference || "",
                trig_date_club: currentDates,
                user_id: user.id || "",
                company_id: user.company_id || "",
            };

            setFormData2(formData);
        }

    };


    const closeModal = () => {
        setShowModal(false);
        setShowModalall(false);
        setShowModalOce(false);
        setShowModalEdit(false);
        setEditColumn("");
        setUtrWarning("");
        setUtrWarningBulk("");
    };

    const openPaymentHistoryModal = (taskuser) => {
        setSelectedPaymentHistory(taskuser.related_paid_fee_all || []);
        setSelectedFeeInfo({
            feeName: taskuser.fees_name ? taskuser.fees_name.name : '',
            totalAmount: taskuser.amount,
            totalPaid: taskuser.ext_6,
            totalDue: taskuser.amount - taskuser.ext_6
        });
        setShowPaymentHistoryModal(true);
    };

    const closePaymentHistoryModal = () => {
        setShowPaymentHistoryModal(false);
        setSelectedPaymentHistory([]);
        setSelectedFeeInfo({});
    };

    // Open individual payment edit modal
    const openEditPaymentModal = (payment) => {
        console.log('payment', payment);
        setEditingPayment(payment);
        setEditPaymentData({
            amount: payment.amount || '',
            ext_1: payment.ext_1 || '',
            ext_2: payment.ext_2 || '',
            alt_date: payment.alt_date ? moment(payment.alt_date).format('YYYY-MM-DD') : moment(payment.created_at).format('YYYY-MM-DD'),
            agent_id: payment.agent_id || ''
        });
        setShowEditPaymentModal(true);
    };

    // Close individual payment edit modal
    const closeEditPaymentModal = () => {
        setShowEditPaymentModal(false);
        setEditingPayment(null);
        setEditPaymentData({
            amount: '',
            ext_1: '',
            ext_2: '',
            alt_date: '',
            agent_id: ''
        });
    };

    // Handle change in edit payment form
    const handleEditPaymentChange = (e) => {
        const { name, value } = e.target;
        setEditPaymentData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Submit individual payment edit
    const submitEditPayment = async (e) => {
        e.preventDefault();
        setPaymentInProgress(true);

        try {
            if (!editingPayment || !editingPayment.id) {
                toast.error("Invalid payment data");
                setPaymentInProgress(false);
                return;
            }

            // Validate amount
            if (!editPaymentData.amount || parseFloat(editPaymentData.amount) <= 0) {
                toast.error("Please enter a valid amount");
                setPaymentInProgress(false);
                return;
            }

            // Prepare the data for API call - using the correct updateFeeIndUpdate format
            const updateData = {
                ext_2: editPaymentData.amount,
                method: editPaymentData.ext_1,
                reff: editPaymentData.ext_2,
                date: editPaymentData.alt_date,
                user_id: user.id,
                agent_id: editPaymentData.agent_id || null,
                paid_id: editingPayment.id
            };

            const response = await http.post(`/fees_edit_ind_update_new/${editingPayment.annual_id}`, updateData);

            if (response.data && response.data.data === 'Updated') {
                closeEditPaymentModal();
                // Refresh the data
                await fetchTaskDetails();
                toast.success("Payment updated successfully!");
            }
        } catch (error) {
            console.error('Error updating payment:', error);
            toast.error(error.response?.data?.error || "Failed to update payment. Please try again.");
        } finally {
            setPaymentInProgress(false);
        }
    };

    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        setPaymentInProgress(true);

        try {
            // Input validation
            if (!editUser?.id) {
                toast.error("Invalid user data: Missing user ID");
                return;
            }

            if (!formData1 || Object.keys(formData1).length === 0) {
                toast.error("Invalid form data: No data to update");
                return;
            }

            // Log transaction start
            console.log(`Starting fee update transaction for user ID: ${editUser.id}`);

            // First API call - fees_edit_ind
            const editResponse = await http.put(`/fees_edit_ind/${editUser.id}`, formData1);

            if (!editResponse?.data) {
                throw new Error('Invalid response from fees_edit_ind');
            }

            // Validate first API response
            if (editResponse.data.data === 'Added') {
                try {
                    // Second API call - fees_add_ind
                    const addResponse = await http.put(`/fees_add_ind/${editUser.id}`, formData1);

                    if (!addResponse?.data) {
                        console.warn('Warning: Unexpected response from fees_add_ind');
                    }

                    // Log successful transaction
                    console.log(`Successfully updated fees for user ID: ${editUser.id}`);
                    toast.success("Fees data updated successfully!");

                } catch (addError) {
                    // Log warning but don't fail the transaction
                    console.warn("Warning: Secondary update failed but primary update successful", {
                        userId: editUser.id,
                        error: addError.message
                    });
                }
            } else {
                throw new Error(`Failed to update fees: ${editResponse.data.message || 'Unknown error'}`);
            }

            // Cleanup and refresh
            setShowModal(false);
            await fetchTaskDetails();

        } catch (error) {
            // Comprehensive error handling
            console.error("Error in fee update transaction:", {
                userId: editUser?.id,
                error: error.message,
                details: error.response?.data
            });

            // User-friendly error message
            toast.error(
                error.response?.data?.message ||
                "Unable to update fees. Please try again or contact support."
            );

        } finally {
            // Reset all states
            setPaymentInProgress(false);
            setEditColumn("");
            setFormData1({});
            setCurrentDate("");

            // Log transaction end
            console.log(`Fee update transaction completed for user ID: ${editUser?.id}`);
        }
    };
    //new function with rollbacks
    const saveEditedCustomerCommitRoll = async (e) => {
        e.preventDefault();

        const reffVal = (formData1.reff || "").trim();
        if (reffVal.toLowerCase().startsWith("utr")) {
            try {
                const res = await http.get(`/check_utr_duplicate?reff=${encodeURIComponent(reffVal)}&company_id=${user.company_id}`);
                if (res.data.duplicate) {
                    setUtrWarning("This Ref No already exists! Please verify before proceeding.");
                    toast.error("Duplicate UTR Ref No found. Payment blocked.");
                    return;
                }
            } catch (err) {
                console.error("UTR check error:", err);
            }
        }

        setPaymentInProgress(true);

        try {
            if (!editUser?.id || !formData1) {
                toast.error("Invalid input data");
                return;
            }

            console.log("Starting transaction...");
            const response = await http.put(`/update_and_add_fees/${editUser.id}`, formData1);

            if (response?.data?.message) {
                toast.success("Fees updated successfully!");
                console.log("Transaction successful:", response.data.message);
            } else {
                throw new Error("Unexpected response from server.");
            }

        } catch (error) {
            console.error("Transaction failed:", error.message);
            toast.error("Failed to update fees. Please try again.");
        } finally {
            setPaymentInProgress(false);
            setShowModal(false);
            await fetchTaskDetails();
        }
    };

    //Edit individual reff amount and method
    const saveEditedCustemerUpdate = async (e) => {
        e.preventDefault();
        setPaymentInProgress(true);
        try {
            if (!editUserUpdate) {
                // Handle the case when editUser is null
                console.error("No user data to edit.");
                return;
            }
            // Make two asynchronous calls concurrently
            const [response1, response2] = await Promise.all([
                http.post(`/fees_edit_ind_update/${editUserUpdate.id}`, formData4),
            ]);

            if (response1) {
                toast.success("Fees data updated successfully!");
                setShowModal(false);
                fetchTaskDetails();
            } else {
                console.log("API response is not an array");
            }

            // You can handle response2 here if needed

        } catch (error) {
            console.error("Error updating user", error);
            if (error.response && error.response.data && error.response.data.error) {
                toast.error(error.response.data.error);
            } else {
                toast.error("An error occurred while updating user");
            }
        }
        setPaymentInProgress(false);
        setEditColumn("");
        closeModal();
    };

    const saveEditedCustemerAll = async (e) => {
        e.preventDefault();

        const refVal = (formData2.reference || "").trim();
        if (refVal.toLowerCase().startsWith("utr")) {
            try {
                const res = await http.get(`/check_utr_duplicate?reff=${encodeURIComponent(refVal)}&company_id=${user.company_id}`);
                if (res.data.duplicate) {
                    setUtrWarningBulk("This Ref No already exists! Please verify before proceeding.");
                    toast.error("Duplicate UTR Ref No found. Payment blocked.");
                    return;
                }
            } catch (err) {
                console.error("UTR check error:", err);
            }
        }

        setPaymentInProgress(true);
        try {
            if (!editUser) {
                console.error("No user data to edit.");
                return;
            }
            const response = await http.post('/fees_add_club', formData2);

            if (response) {
                toast.success("Fees data updated successfully!");
                setShowModalOce(false);
                fetchTaskDetails();
            } else {
                console.log("API response is not an array");
            }

        } catch (error) {
            console.error("Error updating user", error);
            toast.error("An error occurred while updating the customers.");
        } finally {
            setPaymentInProgress(false);
            setEditColumn("");
            setCurrentDates("");
            fetchDataBulkAfterUpdate();
        }
    };


    const saveEditedCustemerEdit = async (e) => {

    }


    const fetchMasterIndividual = async (msterId) => {
        try {
            const response = await http.get(`/master_cat_indi?cat=${msterId}`);
            setMasterdataIndi(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const DropdownOption = ({ user }) => {
        return (
            <option key={user.id} value={user.id}>
                {user.item_name}
            </option>
        );
    };
    if (loading) {
        return <p>Loading...</p>; // You can replace this with a loading spinner or any other loading indicator
    }


    const handleCheckboxChange = (e, taskId) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedItems([...selectedItems, taskId]);
        } else {
            setSelectedItems(selectedItems.filter(id => id !== taskId));
        }
    };
    const handleCheckboxChanges = (e, index) => {
        const isChecked = e.target.checked;
        setSelectedFees(prevSelectedFees => {
            if (isChecked) {
                return [...prevSelectedFees, index];
            } else {
                return prevSelectedFees.filter(i => i !== index);
            }
        });

    };
    const isAnyCheckboxSelected = selectedFees.length > 0;

    const handleChangeModalUpdate = (e, index) => {
        const { name, value } = e.target;
        setBulkData(prevBulkData => {
            const newFormData = [...prevBulkData];
            newFormData[index] = {
                ...newFormData[index],
                [name]: value,
            };
            return newFormData;
        });
    };

    const saveEditedCustomer = async (e) => {
        e.preventDefault();
        const dataToUpdate = bulkData.filter((_, index) => selectedFees.includes(index));
        try {
            await http.post('/update-paid-fees', { fees: dataToUpdate, alt_date: handleDate });
            toast.success("Bulk fees updated successfully!");
            window.location.reload();
        } catch (error) {
            console.error('Error updating fees:', error);
        }
    };

    const handleDelete = async (event, id) => {
        event.preventDefault();
        await http
            .delete(`/fees_del_bul/${id}`)
            .then((response) => {
                toast.success("Fees removed successfully !");
                fetchTaskDetails();
                window.location.reload();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });

    };

    const handleDeleteBulk = async (event, id) => {
        event.preventDefault();

        const userConfirmed = window.confirm("Are you sure you want to delete these fees?");

        if (userConfirmed) {
            await http
                .delete(`/fees_del_bulk/${id}`)
                .then((response) => {
                    toast.success("Fees removed successfully!");
                    setBulkData(prevBulkData => prevBulkData.filter(item => item.id !== id));
                    fetchTaskDetails();
                    window.location.reload();

                })
                .catch((err) => {
                    console.error("Error deleting task", err);
                });
        }
    };

    // Disable the pay button if the selected date is older than three years
    const isDateOlderThanThreeYears = (date) => {
        const selectedDate = new Date(date);
        const threeYearsAgo = new Date();
        threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 2);
        return selectedDate < threeYearsAgo;
    };

    const handlePrintPreview = () => {
        setShowPrintPreview(true);
    };

    const closePrintPreview = () => {
        setShowPrintPreview(false);
    };
    
    const handleNdcPreview = () => {
        setShowNdcPreview(true);
    };

    const closeNdcPreview = () => {
        setShowNdcPreview(false);
    };

    const handleDetailedSummaryPreview = () => {
        setShowDetailedSummaryModal(true);
    };

    const closeDetailedSummaryPreview = () => {
        setShowDetailedSummaryModal(false);
    };

    const printDetailedSummary = () => {
        const printContent = document.getElementById('detailedSummaryPrintableArea');
        
        if (!printContent) {
            console.error("Detailed summary print content not found");
            alert("Error: Could not find the print content. Please try again.");
            return;
        }
        
        const originalContents = document.body.innerHTML;
        
        // B&W-safe print: larger black type (no tiny fonts / no zoom shrink)
        const printStyles = `
            <style>
                @media print {
                    * {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    body {
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 12px;
                        margin: 0;
                        padding: 0;
                        color: #000;
                        background: #fff;
                        font-weight: 500;
                    }
                    
                    h4 {
                        margin: 4px 0 3px 0;
                        font-size: 18px;
                        font-weight: 700;
                        color: #000;
                    }
                    h5 {
                        margin: 6px 0 4px 0;
                        font-size: 14px;
                        font-weight: 700;
                        color: #000;
                        text-transform: uppercase;
                        border-bottom: 2px solid #000;
                        padding-bottom: 2px;
                        display: inline-block;
                    }
                    h6 {
                        margin: 4px 0 3px 0;
                        font-size: 12px;
                        font-weight: 700;
                        color: #000;
                    }
                    
                    /* Section headers: black text + border (works without Background graphics) */
                    .section-header {
                        padding: 6px 8px !important;
                        border-radius: 0 !important;
                        margin-top: 8px !important;
                        margin-bottom: 6px !important;
                        background: #fff !important;
                        border: 2px solid #000 !important;
                        box-shadow: none !important;
                        color: #000 !important;
                    }
                    .section-header h6 {
                        color: #000 !important;
                        font-size: 12px !important;
                        font-weight: 700 !important;
                        margin: 0 !important;
                    }
                    
                    .student-details-box {
                        background: #fff !important;
                        border: 1.5px solid #000 !important;
                        border-radius: 0 !important;
                        padding: 8px !important;
                        margin-bottom: 8px !important;
                        box-shadow: none !important;
                    }
                    .detail-item {
                        display: flex !important;
                        flex-direction: column !important;
                        margin-bottom: 4px;
                    }
                    .detail-label {
                        font-size: 10px !important;
                        color: #000 !important;
                        font-weight: 700 !important;
                        text-transform: uppercase !important;
                        margin-bottom: 1px !important;
                    }
                    .detail-value {
                        font-size: 13px !important;
                        color: #000 !important;
                        font-weight: 700 !important;
                        line-height: 1.25 !important;
                    }
                    .row {
                        display: flex !important;
                        flex-wrap: wrap !important;
                        margin: 0 -8px !important;
                    }
                    .student-details-box > .row {
                        flex-wrap: nowrap !important;
                    }
                    .col-md-4 {
                        flex: 0 0 33.333333% !important;
                        max-width: 33.333333% !important;
                        padding: 0 8px !important;
                    }
                    .col-md-8 {
                        flex: 0 0 66.666667% !important;
                        max-width: 66.666667% !important;
                        padding: 0 8px !important;
                    }
                    
                    .table {
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 11px;
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 8px;
                        border: 1.5px solid #000;
                    }
                    .table th, .table td {
                        padding: 5px 6px;
                        border: 1px solid #000;
                        line-height: 1.3;
                        color: #000 !important;
                        vertical-align: middle;
                    }
                    .table thead th {
                        background: #fff !important;
                        color: #000 !important;
                        font-weight: 700;
                        padding: 6px;
                        font-size: 11px;
                        text-transform: uppercase;
                        border: 1.5px solid #000 !important;
                    }
                    .table-striped tbody tr:nth-of-type(odd),
                    .table-striped tbody tr:nth-of-type(even) {
                        background-color: #fff !important;
                    }
                    .table tbody td strong {
                        font-weight: 700;
                        font-size: 12px;
                        color: #000 !important;
                    }
                    
                    .table td.text-center:first-child,
                    .table td:first-child {
                        font-size: 11px;
                        color: #000 !important;
                        font-weight: 700;
                    }
                    /* Amounts: larger + bold black for B&W printers */
                    .table td.text-end {
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        font-family: Arial, Helvetica, sans-serif !important;
                        color: #000 !important;
                    }
                    .table td.text-end strong,
                    .table td.text-end .text-success,
                    .table td.text-end .text-danger {
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        color: #000 !important;
                    }
                    
                    .table tbody td:nth-child(2) strong {
                        font-size: 12px;
                        color: #000 !important;
                        font-weight: 700;
                    }
                    
                    /* Badges as outlined text — readable without background fill */
                    .badge {
                        padding: 2px 6px;
                        border-radius: 2px;
                        font-size: 10px;
                        font-weight: 700;
                        letter-spacing: 0.2px;
                        text-transform: uppercase;
                        border: 1.5px solid #000 !important;
                        background: #fff !important;
                        color: #000 !important;
                        white-space: nowrap;
                        box-shadow: none !important;
                    }
                    
                    td div[style*="display: flex"] {
                        display: flex !important;
                        align-items: center !important;
                        gap: 4px !important;
                        flex-wrap: nowrap !important;
                    }
                    td div[style*="display: flex"] span:not(.badge) {
                        font-size: 11px !important;
                        color: #000 !important;
                        font-weight: 600 !important;
                        white-space: nowrap !important;
                    }
                    .bg-success,
                    .bg-warning,
                    .bg-danger,
                    .bg-primary,
                    .bg-info,
                    .bg-secondary {
                        background: #fff !important;
                        color: #000 !important;
                        border: 1.5px solid #000 !important;
                    }
                    
                    .table-dark,
                    .table-dark th,
                    .table-secondary,
                    .table-secondary th,
                    .table-light,
                    .table-light th {
                        background: #fff !important;
                        color: #000 !important;
                        font-weight: 700;
                    }
                    
                    .text-center { text-align: center !important; }
                    .text-end { text-align: right !important; }
                    
                    .text-success,
                    .text-danger,
                    .text-primary,
                    .text-muted {
                        color: #000 !important;
                        font-weight: 700 !important;
                    }
                    
                    img[alt="Company Logo"] {
                        max-height: 60px !important;
                        margin-bottom: 4px !important;
                    }
                    img[alt="Student Photo"] {
                        max-height: 120px !important;
                        width: 110px !important;
                        height: 120px !important;
                        object-fit: cover !important;
                        display: inline-block !important;
                        border: 1px solid #000 !important;
                    }
                    
                    p.small, small, .small {
                        font-size: 11px;
                        color: #000;
                    }
                    
                    p {
                        margin: 2px 0;
                        line-height: 1.35;
                        color: #000;
                    }
                    .mb-1, .mb-2, .mb-3, .mb-4 {
                        margin-bottom: 6px !important;
                    }
                    .mt-1, .mt-2, .mt-3, .mt-4 {
                        margin-top: 6px !important;
                    }
                    .p-2, .p-3 {
                        padding: 6px !important;
                    }
                    .fw-bold { 
                        font-weight: 700 !important; 
                    }
                    
                    @page {
                        margin: 8mm;
                        size: A4 portrait;
                    }
                    
                    tfoot td {
                        background: #fff !important;
                        font-weight: 700 !important;
                        font-size: 13px !important;
                        padding: 6px !important;
                        border-top: 2px solid #000 !important;
                        color: #000 !important;
                    }
                }
            </style>
        `;
        
        document.body.innerHTML = printStyles + printContent.innerHTML;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const printDocument = () => {
        // Use a specific selector to find the printable content within the visible modal
        const visibleModal = document.querySelector('.modal[style*="display: block"]');
        const printContent = visibleModal ? visibleModal.querySelector('#printableArea') : null;
        
        if (!printContent) {
            console.error("Print content not found");
            alert("Error: Could not find the print content. Please try again.");
            return;
        }
        
        const originalContents = document.body.innerHTML;

        // Fee Summary print — larger black type for B&W printers
        const printStyles = `
            <style>
                @media print {
                    @page {
                        margin: 8mm;
                        size: A4 portrait;
                    }
                    body {
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 12px;
                        margin: 0;
                        padding: 0;
                        color: #000;
                        font-weight: 500;
                    }
                    .table {
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 12px;
                        width: 100%;
                        border-collapse: collapse;
                    }
                    .table th, .table td {
                        padding: 6px 8px;
                        border: 1px solid #000 !important;
                        color: #000 !important;
                        vertical-align: middle;
                    }
                    .table thead th {
                        background: #fff !important;
                        color: #000 !important;
                        font-weight: 700;
                        font-size: 11px;
                        text-transform: uppercase;
                        border: 1.5px solid #000 !important;
                    }
                    .table td.text-end {
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        font-family: Arial, Helvetica, sans-serif !important;
                        color: #000 !important;
                    }
                    .table td.text-end strong {
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        color: #000 !important;
                    }
                    .table-light,
                    .table-striped tbody tr:nth-of-type(odd),
                    .table-striped tbody tr:nth-of-type(even) {
                        background: #fff !important;
                    }
                    .mb-4 {
                        margin-bottom: 10px !important;
                    }
                    .mb-2 {
                        margin-bottom: 6px !important;
                    }
                    h2 {
                        font-size: 20px !important;
                        color: #000 !important;
                        font-weight: 700 !important;
                    }
                    h3 {
                        font-size: 16px !important;
                        margin: 6px 0;
                        color: #000 !important;
                        font-weight: 700 !important;
                    }
                    h4 {
                        font-size: 14px;
                        margin: 4px 0;
                        color: #000 !important;
                    }
                    h5 {
                        font-size: 13px;
                        margin: 6px 0 4px 0;
                        color: #000 !important;
                        font-weight: 700;
                        border-bottom: 2px solid #000;
                        padding-bottom: 2px;
                        display: inline-block;
                    }
                    p {
                        margin: 3px 0;
                        color: #000 !important;
                        font-size: 12px;
                    }
                    img {
                        max-width: 80px;
                        max-height: 80px;
                    }
                    .border {
                        border: 1.5px solid #000 !important;
                    }
                    .col-md-4, .col-md-8 {
                        padding: 5px;
                    }
                    div[style*="display: flex"] {
                        display: flex !important;
                    }
                    div[style*="flex:"] > div {
                        padding: 0 4px;
                        font-size: 12px !important;
                        color: #000 !important;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .text-end {
                        text-align: right;
                    }
                    .certificate-text {
                        font-size: 14px;
                        line-height: 1.6;
                        margin: 20px 0;
                        color: #000;
                    }
                    .signature-area {
                        margin-top: 40px;
                        text-align: right;
                    }
                    .no-due-message {
                        font-size: 16px;
                        color: #000;
                        font-weight: bold;
                        text-align: center;
                        padding: 20px;
                        border: 1.5px solid #000;
                        margin: 20px 0;
                    }
                }
            </style>
        `;

        try {
        document.body.innerHTML = printStyles + printContent.innerHTML;
        window.print();
        } catch (error) {
            console.error("Error during printing:", error);
            alert("There was an error while preparing the document for printing.");
        } finally {
        document.body.innerHTML = originalContents;
        // Re-render the component after printing
        window.location.reload();
        }
    };
    
    const printNdcDocument = () => {
        // Use a specific selector to find the printable content within the visible modal
        const visibleModal = document.querySelector('.modal[style*="display: block"]');
        const printContentElement = visibleModal ? visibleModal.querySelector('#ndcPrintableArea') : null;
        
        if (!printContentElement) {
            console.error("NDC print content not found");
            alert("Error: Could not find the certificate content. Please try again.");
            return;
        }
        
        const printContent = printContentElement.innerHTML;
        const printWindow = window.open('', '_blank');
        
        // Add professional print styles similar to PrintSt.js
        const ndcPrintStyles = `
            <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
            
            .print-container {
                font-family: 'Poppins', sans-serif;
                max-width: 148mm; /* Half of A4 width */
                margin: 0 auto;
                padding: 15px;
                background: white;
                color: #333;
                font-size: 12px;
                border: 1px solid #ddd;
            }
            
            .receipt-header {
                border-bottom: 1px solid #ddd;
                padding-bottom: 10px;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            
            .company-info {
                text-align: center;
            }
            
            .company-name {
                font-size: 16px;
                font-weight: 600;
                margin: 5px 0;
                text-transform: uppercase;
                color: #2c3e50;
            }
            
            .certificate-title {
                background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%);
                color: white;
                text-align: center;
                padding: 8px;
                font-size: 14px;
                font-weight: 600;
                margin: 5px 0 10px;
                border-radius: 4px;
                text-transform: uppercase;
                letter-spacing: 1px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                position: relative;
            }
            
            .ndc-title {
                text-align: center;
                font-size: 24px;
                font-weight: 600; 
                color: #1a73e8;
                text-transform: uppercase;
                letter-spacing: 2px;
                margin-bottom: 25px;
                padding: 10px 0;
                background: linear-gradient(45deg, #1a73e8, #64b5f6);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                text-shadow: 1px 1px 3px rgba(0,0,0,0.15);
                border-bottom: 2px solid #e8f0fe;
                border-left: 4px solid #1a73e8;
                width: 100%;
                display: block;
            }
            
            .certificate-title:after {
                content: "";
                position: absolute;
                bottom: -4px;
                left: 50%;
                transform: translateX(-50%);
                width: 40%;
                height: 2px;
                background-color: #2E7D32;
            }
            
            .student-info {
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                padding: 10px;
                background-color: #f8f9fa;
                border-radius: 4px;
                font-size: 11px;
            }
            
            .info-section {
                flex: 1;
                padding: 0 5px;
            }
            
            .info-row {
                display: flex;
                align-items: center;
                margin-bottom: 4px;
                padding-bottom: 4px;
                border-bottom: 1px solid #eee;
            }
            
            .info-label {
                font-weight: 500;
                width: 70px;
                flex-shrink: 0;
                color: #555;
                font-size: 10px;
            }
            
            .info-value {
                flex: 1;
                padding-left: 5px;
                font-weight: 600;
                color: #2c3e50;
                font-size: 10px;
            }
            
            .student-photo {
                width: 60px;
                height: 70px;
                border-radius: 4px;
                object-fit: cover;
            }
            
            .no-due-message {
                font-size: 12px;
                color: #2E7D32;
                font-weight: 600;
                text-align: center;
                padding: 10px;
                margin: 10px 0;
                background-color: rgba(76, 175, 80, 0.1);
                border-radius: 4px;
                border-left: 3px solid #4CAF50;
            }
            
            .certificate-text {
                font-size: 10px;
                line-height: 1.4;
                margin: 10px 0;
                padding: 10px;
                background-color: #fff;
                text-align: justify;
                border-radius: 4px;
                border: 1px solid #eee;
            }
            
            .signature-section {
                margin-top: 15px;
                display: flex;
                justify-content: space-between;
                font-size: 10px;
            }
            
            .signature-box {
                text-align: center;
                width: 120px;
            }
            
            .signature-line {
                border-bottom: 1px solid #000;
                margin: 15px 0 5px 0;
            }
            
            .fees-table {
                width: 100%;
                border-collapse: separate;
                border-spacing: 0;
                margin: 10px 0;
                border-radius: 4px;
                overflow: hidden;
                font-size: 9px;
            }
            
            .fees-table th,
            .fees-table td {
                padding: 5px;
                text-align: left;
                border-bottom: 1px solid #eee;
            }
            
            .fees-table th {
                background: #3498db;
                color: white;
                font-weight: 500;
                text-transform: uppercase;
                font-size: 9px;
            }
            
            .fees-table tr:last-child td {
                border-bottom: none;
            }
            
            .fees-table tr:nth-child(even) {
                background-color: #f8f9fa;
            }
            
            .fees-table .total-row {
                background-color: #edf7ed;
                font-weight: 600;
            }
            
            .fees-table .total-row td {
                color: #2E7D32;
            }
            
            .section-title {
                font-size: 12px;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 5px;
                padding-bottom: 5px;
                border-bottom: 1px solid #eee;
            }
            
            .official-seal {
                position: absolute;
                bottom: 50px;
                left: 50px;
                font-size: 9px;
                font-style: italic;
                color: #777;
            }
            
            @media print {
                body {
                    margin: 0;
                    padding: 0;
                }
                .print-container {
                    max-width: 210mm; /* A4 width */
                    margin: 0 auto;
                    padding: 2mm 15mm;
                    position: relative;
                    box-shadow: none;
                    border-radius: 0;
                    border: none;
                    page-break-inside: auto;
                }
                table {
                    page-break-inside: auto;
                }
                tr {
                    page-break-inside: avoid;
                    page-break-after: auto;
                }
                thead {
                    display: table-header-group;
                }
                .signature-section {
                    page-break-inside: avoid;
                }
                .certificate-title {
                    background: #4CAF50;
                    box-shadow: none;
                }
                
                /* Fix for blue border in title */
                .ndc-title {
                    border-left: 0 !important;
                    color: #1a73e8 !important;
                    background: none !important;
                    -webkit-text-fill-color: #1a73e8 !important;
                    font-size: 22px !important;
                    font-weight: bold !important;
                    letter-spacing: 2px !important;
                    margin: 0 auto 20px !important;
                    padding: 5px 0 !important;
                    display: block !important;
                    width: 100% !important;
                    text-align: center !important;
                }
                .fees-table th {
                    background: #3498db;
                }
                @page {
                    margin: 0;
                    size: A4;
                }
            }
            </style>
        `;
        
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>No Due Certificate</title>
                    ${ndcPrintStyles}
                    <style>
                        body {
                            margin: 0;
                            padding: 0;
                            height: auto;
                            overflow: auto;
                        }
                        .page {
                            display: flex;
                            justify-content: center;
                            padding: 0;
                        }
                        .print-container {
                            position: relative;
                            max-height: 277mm; /* A4 height */
                            padding-bottom: 20% !important; /* Reduced blank space at bottom */
                        }
                        @media print {
                            html, body {
                                height: 99%;
                                overflow: hidden;
                            }
                            .page {
                                page-break-inside: avoid;
                                page-break-after: avoid;
                                page-break-before: avoid;
                                height: 100%;
                                overflow: hidden;
                            }
                            .print-container {
                                overflow: hidden;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="page">
                        <div class="print-container">${printContent}</div>
                    </div>
                </body>
            </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();
        
        printWindow.onafterprint = () => {
            printWindow.close();
        };
        
        printWindow.print();
    };

    return (
        <>
            <Toaster />

            {/* individual first pay */}
            {showModal && (
                <form onSubmit={saveEditedCustomerCommitRoll}>
                    <div className="modal" tabindex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog modal-dialog-scrollable" style={{ maxHeight: '92vh' }}>
                            <div className="modal-content" style={{ maxHeight: '90vh' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Fees
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    {students.map((student) => (
                                        <div className="d-flex align-items-center gap-2 mb-2 border border-success rounded" style={{ padding: '8px 12px', fontSize: '0.82rem' }}>
                                            <div className="flex-shrink-0">
                                                {student.photo ? (
                                                    <img src={getImageUrl(student.photo)} alt="Photo" style={{ width: '50px', height: '55px', objectFit: 'cover', borderRadius: '4px' }} />
                                                ) : (
                                                    <img src="/dummy.jpg" alt="photo" style={{ width: '50px', height: '55px', objectFit: 'cover', borderRadius: '4px' }} />
                                                )}
                                            </div>
                                            <div className="flex-grow-1" style={{ lineHeight: 1.4 }}>
                                                <div className="fw-bold text-primary" style={{ fontSize: '0.9rem' }}>{student.ext_2} {student.ext_3}</div>
                                                <div className="text-muted"><span className="fw-semibold text-dark">Adm:</span> {student.adm_no} &nbsp;|&nbsp; <span className="fw-semibold text-dark">Class:</span> {student.class} &nbsp;|&nbsp; <span className="fw-semibold text-dark">Div:</span> {student.section}</div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="form-group mt-3">
                                        <label>Pending Amount</label>
                                        <input type="number"
                                            name="ext_2"
                                            className="form-control"
                                            value={formData1.ext_2}
                                            disabled={formData1.ext_2 == 0 && formData1.ext_2 != ''}
                                            onChange={handleChangeModal}
                                        />
                                    </div>
                                    {isAmountValidPay && <p className="text-danger">Amount is greater than the actual pending amount.</p>}

                                    {isAmountValidPayNag && <p className="text-danger">Amount is less than zero</p>}


                                    <div className="form-group mt-3">
                                        <label>Payment Methods</label>
                                        <select className="form-control" value={formData1.method}
                                            onChange={handleChangeModal} name="method" required>
                                            <option value="">Select</option>
                                            <option value="Cash">Cash</option>
                                            <option value="UPI">UPI/Card</option>
                                            <option value="Dbank">Dbank</option>
                                            <option value="Concession">Concession</option>
                                            <option value="Agent">Other</option>
                                        </select>
                                    </div>

                                    {formData1.method === "Agent" && (
                                        <div className="form-group mt-3">
                                            <label>Select Agent</label>
                                            <Select
                                                options={agent.map((depart) => ({
                                                    value: depart.id,
                                                    label: depart.name
                                                }))}
                                                onChange={(selectedOption) => {
                                                    const syntheticEvent = {
                                                        target: {
                                                            name: 'agent_id',
                                                            value: selectedOption ? selectedOption.value : ''
                                                        }
                                                    };
                                                    handleChangeModal(syntheticEvent);
                                                }}
                                                value={agent.find(depart => depart.id === formData1.agent_id) ? {
                                                    value: formData1.agent_id,
                                                    label: agent.find(depart => depart.id === formData1.agent_id).name
                                                } : null}
                                                isSearchable={true}
                                                placeholder="Select agent..."
                                                isClearable={true}
                                                noOptionsMessage={() => "No agents found"}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid #ced4da',
                                                        minHeight: '38px',
                                                        height: '38px'
                                                    }),
                                                    menuPortal: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                            <input
                                                type="hidden"
                                                name="agent_id"
                                                value={formData1.agent_id || ""}
                                                required={formData1.method === "Agent"}
                                            />
                                        </div>
                                    )}

                                    <div className="form-group mt-3"
                                        onChange={handleChangeModal} required>
                                        <label>Ref No</label>
                                        <input type="text" value={formData1.reff} name="reff" required
                                            className={`form-control ${utrWarning ? 'border-warning' : ''}`}
                                            onBlur={(e) => checkUtrDuplicate(e.target.value, setUtrWarning)}
                                        />
                                        {utrWarning && <small className="text-warning fw-bold">{utrWarning}</small>}
                                    </div>

                                    <div className="form-group mt-3"
                                        onChange={handleChangeModal} required>
                                        <label>Date</label>
                                        <input type="date" value={currentDate} onChange={e => setCurrentDate(e.target.value)} name="trig_date"
                                            className="form-control" max={minDate}
                                        />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className="btn btn-primary" disabled={paymentInProgress || isAmountValidPay || isAmountValidPayNag || formData1.ext_2 == 0 || isDateOlderThanThreeYears(currentDate) || !!utrWarning}>
                                        {paymentInProgress ? 'Processing...' : 'Pay'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}

            {showModalAll && (
                <form onSubmit={saveEditedCustomer}>
                    <div className="modal" tabindex="-1" style={{ display: "block" }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Bulk Paid Fees</h5>
                                    <button type="button" className="btn-close" onClick={closeModal}></button>
                                </div>
                                <div className="modal-body">
                                    {students.map((student) => (
                                        <div className="row mb-3 border border-success">
                                            <div className="col-md-8 p-4">
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Name:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.ext_2} {student.ext_3}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Adm-No:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.adm_no}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Course:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.class}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Division:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.section}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                {student.photo ? (
                                                    <img
                                                        src={getImageUrl(student.photo)}
                                                        width="135"
                                                        height="145"
                                                        alt="Photo"
                                                    />
                                                ) : (
                                                    <img src="/dummy.jpg" alt="photo" width="135" height="145" />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Check</th>
                                                <th scope="col">Fees Name</th>
                                                <th scope="col">Mode</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">Reff</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bulkData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`fee${index}`}
                                                            name={`fee${index}`}
                                                            onChange={(e) => handleCheckboxChanges(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <label className="form-label" htmlFor={`fee${index}`}><b>{item.fees_name.name}</b></label>
                                                    </td>
                                                    <td>
                                                        <div className="form-group">
                                                            <select
                                                                className="form-control"
                                                                defaultValue={item.ext_1 || ''}
                                                                name="ext_1"
                                                                onChange={(e) => handleChangeModalUpdate(e, index)}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Cash">Cash</option>
                                                                <option value="UPI">UPI/Card</option>
                                                                <option value="Dbank">Dbank</option>
                                                                <option value="Concession">Concession</option>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <h6
                                                        >{item.amount || ''}</h6>

                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue={item.ext_2 || ''}
                                                            name="ext_2"
                                                            onChange={(e) => handleChangeModalUpdate(e, index)}
                                                        />
                                                    </td>

                                                    <td width="14%">
                                                        {moment(item.alt_date).format("DD-MM-YYYY")}
                                                    </td>
                                                    <td className="trash-bulk">
                                                        {user.status === 1 && user.department_id === 1 &&
                                                            <a href="#" onClick={(e) => handleDeleteBulk(e, item.id)}>🚮</a>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}


                                        </tbody>
                                    </table>
                                    {/* Add your validation messages here */}
                                </div>

                                <div className="modal-footer">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label for="alt_date">Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="alt_date"
                                                        onChange={(e) => handleChangeDate(e.target.value)} max={minDate}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                                    <button type="submit" className="btn btn-primary" disabled={!isAnyCheckboxSelected}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form >
            )
            }

            {/* //Bulk pay */}
            {
                showModalOnce && (
                    <form onSubmit={saveEditedCustemerAll}>
                        <div className="modal" tabindex="-1" style={{ display: "block" }}>
                            <div className="modal-dialog modal-dialog-scrollable" style={{ maxHeight: '92vh' }}>
                                <div className="modal-content" style={{ maxHeight: '90vh' }}>
                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            Bulk Pay
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={closeModal}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {students.map((student) => (
                                            <div className="d-flex align-items-center gap-2 mb-2 border border-success rounded" style={{ padding: '8px 12px', fontSize: '0.82rem' }}>
                                                <div className="flex-shrink-0">
                                                    {student.photo ? (
                                                        <img src={getImageUrl(student.photo)} alt="Photo" style={{ width: '50px', height: '55px', objectFit: 'cover', borderRadius: '4px' }} />
                                                    ) : (
                                                        <img src="/dummy.jpg" alt="photo" style={{ width: '50px', height: '55px', objectFit: 'cover', borderRadius: '4px' }} />
                                                    )}
                                                </div>
                                                <div className="flex-grow-1" style={{ lineHeight: 1.4 }}>
                                                    <div className="fw-bold text-primary" style={{ fontSize: '0.9rem' }}>{student.ext_2} {student.ext_3}</div>
                                                    <div className="text-muted"><span className="fw-semibold text-dark">Adm:</span> {student.adm_no} &nbsp;|&nbsp; <span className="fw-semibold text-dark">Class:</span> {student.class} &nbsp;|&nbsp; <span className="fw-semibold text-dark">Div:</span> {student.section}</div>
                                                </div>
                                            </div>
                                        ))}
                                        {totalSum < 0 && <span className="badge bg-danger ms-2 mb-2">There is no due payment</span>}
                                        <div className="form-group mt-3">
                                            <label>Total Pending Amount</label>
                                            <input
                                                type="number"
                                                name="amount"
                                                className="form-control"
                                                value={totalSum >= 0 ? totalSum : 'Loading...'}
                                                onChange={handleChangeModalOnce}
                                                disabled
                                            />
                                        </div>

                                        <div className="form-group mt-3">
                                            <label>Payment Method</label>
                                            <select className="form-control" value={formData2.type}
                                                onChange={handleChangeModalOnce} name="type" required>
                                                <option value="">Select</option>
                                                <option value="Cash">Cash</option>
                                                <option value="UPI">UPI/Card</option>
                                                <option value="Dbank">Dbank</option>
                                                <option value="Concession">Concession</option>
                                                {/* <option value="Agent">Agent</option> */}

                                            </select>
                                        </div>

                                        <div className="form-group mt-3">
                                            <label>Ref No</label>
                                            <input type="text" value={formData2.reference}
                                                onChange={handleChangeModalOnce} name="reference"
                                                className={`form-control ${utrWarningBulk ? 'border-warning' : ''}`}
                                                disabled={paymentInProgress || totalSum < 0}
                                                onBlur={(e) => checkUtrDuplicate(e.target.value, setUtrWarningBulk)}
                                                required />
                                            {utrWarningBulk && <small className="text-warning fw-bold">{utrWarningBulk}</small>}
                                        </div>

                                        <div className="form-group mt-3">
                                            <label>Date</label>

                                            <input type="date" value={currentDates} onChange={e => {
                                                setCurrentDates(e.target.value);
                                                handleChangeModalOnce(e);
                                            }} name="trig_date_club" className="form-control" max={minDate} />
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={closeModal}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={paymentInProgress || totalSum <= 0 || isDateOlderThanThreeYears(currentDates) || !!utrWarningBulk}
                                        >
                                            {paymentInProgress ? 'Processing...' : 'Pay All'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )
            }

            {/* for individual update modal */}
            {
                showModalEdit && (
                    <form onSubmit={saveEditedCustemerUpdate}>
                        <div className="modal" tabindex="-1" style={{ display: "block" }}>
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            Fees
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={closeModal}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group mt-3">
                                            <label>Paid Amount</label>
                                            <input type="number"
                                                name="ext_2"
                                                className="form-control"
                                                value={formData4.ext_2}
                                                onChange={handleChangeModalEdit}
                                            />
                                        </div>
                                        {isAmountValidPayEdit && <p className="text-danger">Amount is greater than the actual pending amount.</p>}

                                        {isAmountValidPayNag && <p className="text-danger">Amount is less than zero</p>}


                                        <div className="form-group mt-3">
                                            <label>Payment Method</label>
                                            <select className="form-control" value={formData4.method}
                                                onChange={handleChangeModalEdit} name="method" required>
                                                <option value="">Select</option>
                                                <option value="Cash">Cash</option>
                                                <option value="UPI">UPI/Card</option>
                                                <option value="Dbank">Dbank</option>
                                                <option value="Concession">Concession</option>
                                                <option value="Agent">Agent</option>
                                            </select>
                                        </div>

                                        {formData4.method === "Agent" && (
                                            <div className="form-group mt-3">
                                                <label>Select Agent</label>
                                                <select className="form-control" name="agent_id" onChange={handleChangeModalEdit}
                                                    value={formData4.agent_id} required
                                                >
                                                    <option value="">Select any</option>
                                                    {agent.map((depart) => (
                                                        <option key={depart.id} value={depart.id}>
                                                            {depart.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        <div className="form-group mt-3"
                                            onChange={handleChangeModalEdit}>
                                            <label>Ref No</label>
                                            <input type="text" value={formData4.reff} name="reff"
                                                className="form-control" required
                                            />
                                        </div>

                                        <div className="form-group mt-3"
                                            onChange={handleChangeModalEdit}>
                                            <label>Date</label>
                                            <input type="date" onChange={(e) => handleChangeModalEdit(e.target.value)} max={minDate} name="date"
                                                className="form-control"
                                            />
                                            <label>Date: {moment(formData4.date).format("DD-MM-YYYY")}</label>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={closeModal}
                                        >
                                            Close
                                        </button>
                                        <button type="submit" className="btn btn-primary" disabled={paymentInProgress || isAmountValidPayEdit || isAmountValidPayNag}>
                                            {paymentInProgress ? 'Processing...' : 'Update'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )
            }

            {/* Print Preview Modal */}
            {showPrintPreview && (
                <div className="modal" tabIndex="-1" style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {}}>Fee Summary - Print Preview</h5>
                                <button type="button" className="btn-close" onClick={closePrintPreview}></button>
                            </div>
                            <div className="modal-body">
                                <div id="printableArea">
                                    <div style={{marginBottom: '20px'}}>
                                        {/* Header with Logo, School Name, and Student Photo */}
                                        <div style={{display: 'flex', alignItems: 'center', borderBottom: '2px solid #4CAF50', paddingBottom: '15px', marginBottom: '15px'}}>
                                            {/* Left: Logo */}
                                            <div style={{width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee', padding: '5px', backgroundColor: '#fff'}}>
                                                <img
                                                    src={getCompanyLogoUrl ? getCompanyLogoUrl(companylogo) : "/logo.png"}
                                                    alt="Company Logo"
                                                    style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}
                                                />
                                            </div>
                                            
                                            {/* Center: School Name */}
                                            <div style={{flex: '1', textAlign: 'center', margin: '0 15px'}}>
                                                <h2 style={{fontSize: '24px', fontWeight: 'bold', color: user.company_id === 40 ? '#890015' : '#333', margin: '0 0 8px 0', textTransform: 'uppercase', fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'}}>{companyname}</h2>
                                                <div style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>{companyaddr}</div>
                                                <h3 style={{fontSize: '20px', fontWeight: '600', color: user.company_id === 40 ? '#890015' : '#1a73e8', margin: '8px 0 0 0', fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'}}>FEE SUMMARY</h3>
                                                <p style={{fontSize: '13px', margin: '5px 0', color: '#666'}}>Date: {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}</p>
                                            </div>
                                            
                                            {/* Right: Student Photo */}
                                            <div style={{width: '100px', height: '100px', border: '2px solid #ddd', borderRadius: '4px', overflow: 'hidden'}}>
                                                {students.length > 0 && (
                                                    students[0].photo ? (
                                                        <img
                                                            src={getImageUrl(students[0].photo)}
                                                            alt="Student Photo"
                                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                                        />
                                                    ) : (
                                                        <img 
                                                            src="/dummy.jpg" 
                                                            alt="Student Photo" 
                                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {students.length > 0 && (
                                        <div style={{border: '1px solid #333', padding: '10px', marginBottom: '12px', fontFamily: 'Arial, Helvetica, sans-serif'}}>
                                            {/* Row 1 */}
                                            <div style={{display: 'flex', marginBottom: '6px', fontSize: '13px', color: '#000'}}>
                                                <div style={{flex: '2'}}><strong>Name:</strong> {students[0].ext_2} {students[0].ext_3}</div>
                                                <div style={{flex: '1'}}><strong>Adm No:</strong> {students[0].adm_no}</div>
                                                <div style={{flex: '1'}}><strong>Class:</strong> {students[0].class}</div>
                                            </div>
                                            {/* Row 2 */}
                                            <div style={{display: 'flex', fontSize: '13px', color: '#000'}}>
                                                <div style={{flex: '1'}}><strong>Division:</strong> {students[0].section}</div>
                                                <div style={{flex: '3'}}><strong>Institution:</strong> {students[0].tc_num || 'N/A'}</div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="fee-summary mb-4" style={{fontFamily: 'Arial, Helvetica, sans-serif'}}>
                                        <h5 style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {fontSize: '14px', fontWeight: 700, color: '#000'}}>Fee Summary</h5>
                                        <table className="table table-bordered" style={{fontSize: '13px', color: '#000'}}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Description</th>
                                                    <th className="text-end">Amount (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Total Amount</td>
                                                    <td className="text-end" style={{fontWeight: 700, fontSize: '14px'}}>{totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                </tr>
                                                <tr>
                                                    <td>Total Paid</td>
                                                    <td className="text-end" style={{fontWeight: 700, fontSize: '14px'}}>{totalPaid.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                </tr>
                                                <tr className="table-light">
                                                    <td><strong>Due Amount</strong></td>
                                                    <td className="text-end"><strong style={{fontSize: '14px'}}>{totalDue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="fee-details" style={{fontFamily: 'Arial, Helvetica, sans-serif'}}>
                                        <h5 style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {fontSize: '14px', fontWeight: 700, color: '#000'}}>Fee Details</h5>
                                        <table className="table table-bordered table-striped" style={{fontSize: '13px', color: '#000'}}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th>No</th>
                                                    <th>Fee Name</th>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>Due</th>
                                                    <th>Due Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tasks.map((task, index) => (
                                                    <tr key={task.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{task.fees_name ? task.fees_name.name : ''}</td>
                                                        <td className="text-end" style={{fontWeight: 700, fontSize: '14px'}}>{parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                        <td className="text-end" style={{fontWeight: 700, fontSize: '14px'}}>{parseFloat(task.ext_6 || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                        <td className="text-end" style={{fontWeight: 700, fontSize: '14px'}}>{(parseFloat(task.amount) - parseFloat(task.ext_6 || 0)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                        <td>{(parseFloat(task.amount) - parseFloat(task.ext_6 || 0)) === 0 ? '' : task.ext_5 ? moment(task.ext_5).format("DD-MM-YYYY") : ''}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closePrintPreview}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={printDocument}>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {/* No Due Certificate Modal */}
            {showNdcPreview && (
                <div className="modal" tabIndex="-1" style={{ display: "block" }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {}}>{totalDue <= 0 ? "NO DUE CERTIFICATE" : "DUE CERTIFICATE"} - Print Preview</h5>
                                <button type="button" className="btn-close" onClick={closeNdcPreview}></button>
                            </div>
                            <div className="modal-body">
                                                                <div id="ndcPrintableArea" style={{position: 'relative'}}>
                                    <div style={{marginBottom: '5px'}}>
                                        
                                        
                                        <div style={{display: 'flex', alignItems: 'center', borderBottom: '1px solid #4CAF50', paddingBottom: '5px', marginBottom: '5px'}}>
                                            {/* Left: Logo */}
                                            <div style={{width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee', padding: '5px', backgroundColor: '#fff'}}>
                                                <img
                                                    src={getCompanyLogoUrl ? getCompanyLogoUrl(companylogo) : "/logo.png"}
                                                    alt="Company Logo"
                                                    style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}
                                                />
                                            </div>
                                            
                                            {/* Center: School Name */}
                                            <div style={{flex: '1', textAlign: 'center', margin: '0 15px'}}>
                                                <h2 style={{fontSize: '22px', fontWeight: 'bold', color: user.company_id === 40 ? '#890015' : '#333', margin: '0 0 5px 0', textTransform: 'uppercase', fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'}}>{companyname}</h2>
                                                <div style={{fontSize: '12px', color: '#666'}}>{companyaddr}</div>
                                            </div>
                                            
                                            {/* Right: Student Photo */}
                                            <div style={{width: '80px', height: '80px', border: '1px solid #eee'}}>
                                                {students.length > 0 && (
                                                    students[0].photo ? (
                                                        <img
                                                            src={getImageUrl(students[0].photo)}
                                                            alt="Student Photo"
                                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                                        />
                                                    ) : (
                                                        <img 
                                                            src="/dummy.jpg" 
                                                            alt="Student Photo" 
                                                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div style={{borderBottom: '1px solid #ddd', marginBottom: '10px'}}></div>
                                    </div>
                                    {totalDue <= 0 ? (
                                        <div>
                                            <div className="ndc-title" style={{
                                        textAlign: 'center',
                                                fontSize: '24px',
                                                fontWeight: '600',
                                        color: user.company_id === 40 ? '#890015' : '#1a73e8',
                                        textTransform: 'uppercase',
                                                letterSpacing: '2px',
                                                marginBottom: '25px',
                                                padding: '10px 0',
                                                width: '100%',
                                                display: 'block',
                                                fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'
                                    }}>
                                        NO DUE CERTIFICATE
                                    </div>
                                    {students.length > 0 && (
                                        <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '20px'}}>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Date:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}></div>
                                                            <div style={{flex: '1', paddingBottom: '2px', fontSize: '14px'}}></div>
                                                        </div>
                                                    </div>
                                            <div style={{width: '50%', marginBottom: '10px'}}>
                                                <div style={{display: 'flex'}}>
                                                    <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Name:</div>
                                                    <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].ext_2} {students[0].ext_3}</div>
                                                </div>
                                            </div>
                                            <div style={{width: '50%', marginBottom: '10px'}}>
                                                <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Course:</div>
                                                    <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].class}</div>
                                                </div>
                                            </div>
                                            <div style={{width: '50%', marginBottom: '10px'}}>
                                                <div style={{display: 'flex'}}>
                                                    <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Adm No:</div>
                                                    <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].adm_no}</div>
                                                </div>
                                            </div>
                                            <div style={{width: '50%', marginBottom: '10px'}}>
                                                <div style={{display: 'flex'}}>
                                                    <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Division:</div>
                                                    <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].section}</div>
                                                </div>
                                            </div>
                                            <div style={{width: '50%', marginBottom: '10px'}}>
                                                <div style={{display: 'flex'}}>
                                                    <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Institution:</div>
                                                    <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].tc_num || 'N/A'}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                            <div style={{padding: '6px', background: '#e8f5e9', border: '1px solid #4CAF50', borderRadius: '4px', textAlign: 'center', margin: '10px 0', color: '#2E7D32', fontWeight: '500', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                                THIS IS TO CERTIFY THAT THERE ARE NO PENDING DUES FOR THIS STUDENT.
                                            </div>
                                            

                                            
                                            <div style={{margin: '10px 0', fontSize: '14px'}}>
                                                <div style={{fontSize: '16px', fontWeight: '500', color: user.company_id === 40 ? '#890015' : '#333', marginBottom: '10px', textAlign: 'center', fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'}}>FEES SUMMARY</div>
                                                <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd', marginBottom: '10px'}}>
                                                    <thead>
                                                        <tr style={{backgroundColor: '#f8f9fa'}}>
                                                            <th style={{padding: '6px', textAlign: 'center', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>SL NO.</th>
                                                            <th style={{padding: '6px', textAlign: 'center', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>YEAR</th>
                                                            <th style={{padding: '6px', textAlign: 'center', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>DUE AMOUNT</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="3" style={{padding: '8px', textAlign: 'center', fontSize: '14px', fontWeight: '500', color: '#2E7D32'}}>NIL</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            <div style={{
                                                marginTop: '20px',
                                                fontSize: '12px',
                                                fontStyle: 'italic',
                                                color: '#666',
                                                textAlign: 'left',
                                                marginBottom: '10px'
                                            }}>
                                                Note: Issued on request, valid as of the above date only.
                                            </div>
                                            
                                            <div className="signature-section" style={{
                                                marginTop: '10px',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                paddingRight: '30px'
                                            }}>
                                                <div className="signature-box" style={{
                                                    textAlign: 'center',
                                                    width: '180px'
                                                }}>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#333',
                                                        textTransform: 'uppercase'
                                                    }}>{user.name}</div>
                                                    <div className="signature-line" style={{
                                                        borderBottom: '1px solid #000',
                                                        margin: '5px 0'
                                                    }}></div>
                                                    <div style={{
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        color: '#444',
                                                        textAlign: 'center'
                                                    }}>Issued By</div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="ndc-title" style={{
                                                textAlign: 'center',
                                                fontSize: '24px',
                                                fontWeight: '600',
                                                color: user.company_id === 40 ? '#890015' : '#1a73e8',
                                                textTransform: 'uppercase',
                                                letterSpacing: '2px',
                                                marginBottom: '25px',
                                                padding: '10px 0',
                                                width: '100%',
                                                display: 'block',
                                                fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'
                                            }}>
                                                DUE CERTIFICATE
                                            </div>
                                            {students.length > 0 && (
                                                <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '20px'}}>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Date:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}></div>
                                                            <div style={{flex: '1', paddingBottom: '2px', fontSize: '14px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Name:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].ext_2} {students[0].ext_3}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Course:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].class}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Adm No:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].adm_no}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Division:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].section}</div>
                                                        </div>
                                                    </div>
                                                    <div style={{width: '50%', marginBottom: '10px'}}>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '100px', fontSize: '14px', color: '#333', fontWeight: '500'}}>Institution:</div>
                                                            <div style={{flex: '1', borderBottom: '1px solid #ddd', paddingBottom: '2px', fontSize: '14px'}}>{students[0].tc_num || 'N/A'}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div style={{margin: '10px 0', fontSize: '14px'}}>
                                                <div style={{fontSize: '16px', fontWeight: '500', color: user.company_id === 40 ? '#890015' : '#333', marginBottom: '5px', textAlign: 'center', fontFamily: user.company_id === 40 ? 'Bookman Old Style' : 'inherit'}}>FEE DETAILS</div>
                                                <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd', marginBottom: '10px'}}>
                                                <thead>
                                                        <tr style={{backgroundColor: '#f8f9fa'}}>
                                                            <th style={{padding: '6px', textAlign: 'left', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>No</th>
                                                            <th style={{padding: '6px', textAlign: 'left', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>Fee Name</th>
                                                            <th style={{padding: '6px', textAlign: 'right', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>Total</th>
                                                            <th style={{padding: '6px', textAlign: 'right', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>Paid</th>
                                                            <th style={{padding: '6px', textAlign: 'right', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>Due</th>
                                                            <th style={{padding: '6px', textAlign: 'left', borderBottom: '1px solid #ddd', color: '#333', fontWeight: '500', fontSize: '14px'}}>Due Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        {tasks.map((task, index) => (
                                                            <tr key={task.id} style={{backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9'}}>
                                                            <td style={{padding: '8px', textAlign: 'left', borderBottom: '1px solid #eee', fontSize: '13px'}}>{index + 1}</td>
                                                            <td style={{padding: '8px', textAlign: 'left', borderBottom: '1px solid #eee', fontSize: '13px'}}>{task.fees_name ? task.fees_name.name : ''}</td>
                                                            <td style={{padding: '8px', textAlign: 'right', borderBottom: '1px solid #eee', fontSize: '13px'}}>{parseFloat(task.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                            <td style={{padding: '8px', textAlign: 'right', borderBottom: '1px solid #eee', fontSize: '13px'}}>{parseFloat(task.ext_6 || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                <td style={{padding: '8px', textAlign: 'right', borderBottom: '1px solid #eee', fontSize: '13px', fontWeight: '500', color: '#d32f2f'}}>{(parseFloat(task.amount) - parseFloat(task.ext_6 || 0)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                            <td style={{padding: '8px', textAlign: 'left', borderBottom: '1px solid #eee', fontSize: '13px'}}>{(parseFloat(task.amount) - parseFloat(task.ext_6 || 0)) === 0 ? '' : task.ext_5 ? moment(task.ext_5).format("DD-MM-YYYY") : ''}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            </div>
                                            
                                            <div style={{
                                                marginTop: '20px',
                                                fontSize: '12px',
                                                fontStyle: 'italic',
                                                color: '#666',
                                                textAlign: 'left',
                                                marginBottom: '10px'
                                            }}>
                                                Note: Issued on request, valid as of the above date only.
                                            </div>
                                            
                                            <div className="signature-section" style={{
                                                marginTop: '10px',
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                paddingRight: '30px'
                                            }}>
                                                <div className="signature-box" style={{
                                                    textAlign: 'center',
                                                    width: '180px'
                                                }}>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#333',
                                                        textTransform: 'uppercase'
                                                    }}>{user.name}</div>
                                                    <div className="signature-line" style={{
                                                        borderBottom: '1px solid #000',
                                                        margin: '5px 0'
                                                    }}></div>
                                                    <div style={{
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        color: '#444',
                                                        textAlign: 'center'
                                                    }}>Issued By</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeNdcPreview}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={printNdcDocument}>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {
                students.length > 0 ? (
                    <div className="container mt-1">
                        <div className="container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3>Fees List</h3>

                                <div>
                                    <button
                                        className="btn btn-outline-primary me-2"
                                        onClick={handlePrintPreview}
                                        title="Print Fee Summary"
                                    >
                                        <FontAwesomeIcon icon={faFile} /> Print Summary
                                    </button>
                                    <button
                                        className="btn btn-outline-info me-2"
                                        onClick={handleDetailedSummaryPreview}
                                        title="Detailed Summary with Individual Payments"
                                    >
                                        <FontAwesomeIcon icon={faFile} /> Detailed Summary
                                    </button>
                                    <button
                                        className="btn btn-outline-success"
                                        onClick={handleNdcPreview}
                                        title="No Due Certificate"
                                    >
                                        <FontAwesomeIcon icon={faFile} /> NDC
                                    </button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <div className="table">
                                    {students.map((student) => (
                                        <div className="row mb-3 border border-success">
                                            <div className="col-md-8 p-4">
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Name:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.ext_2} {student.ext_3}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Adm-No:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.adm_no}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Course:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.class}</h6>
                                                    </div>
                                                </div>
                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Division:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.section}</h6>
                                                    </div>
                                                </div>

                                                <div className="row mb-1">
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0">Through:</h6>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="mb-0 text-primary">{student.ext_11 || '-'}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                {student.photo ? (
                                                    <img
                                                        src={getImageUrl(student.photo)}
                                                        width="135"
                                                        height="145"
                                                        alt="Photo"
                                                    />
                                                ) : (
                                                    <img src="/dummy.jpg" alt="photo" width="135" height="145" />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>


                        {/* Year Filter Tabs */}
                        {availableYears.length > 1 && (
                            <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                <small className="fw-bold text-muted me-1">Academic Year:</small>
                                {availableYears.map((yr) => (
                                    <button key={yr} className={`btn btn-sm px-3 py-1 ${selectedYear === yr ? 'btn-primary' : 'btn-outline-secondary'}`} style={{ fontSize: '0.8rem', borderRadius: '20px' }} onClick={() => setSelectedYear(yr)}>
                                        {yr}
                                    </button>
                                ))}
                                <button className={`btn btn-sm px-3 py-1 ${selectedYear === 'all' ? 'btn-dark' : 'btn-outline-dark'}`} style={{ fontSize: '0.8rem', borderRadius: '20px' }} onClick={() => setSelectedYear('all')}>
                                    All
                                </button>
                            </div>
                        )}

                        <div className="table-responsive">
                            {isLoading ? (
                                <TaskSkeleton />
                            ) : (
                                <>
                                    <table className="table table-striped center_tbl">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Check</th>
                                                <th className="text-danger">No</th>
                                                <th>Name</th>
                                                <th>Year</th>
                                                {/* <th>Class</th>
                                                <th>Div</th> */}
                                                <th>Type</th>
                                                <th>Total Amount <br></br><span className="text-white">( ₹{totalAmount.toFixed(2)} )</span></th>
                                                <th>Total Paid <br></br><span className="text-white">( ₹{totalPaid.toFixed(2)} )</span></th>
                                                <th>Due Amount <br></br><span className="text-white">( ₹{totalDue.toFixed(2)} )</span></th>
                                                <th>Due Date</th>
                                                <th>Paid Date</th>
                                                <th>Action</th>

                                                {/* Add other fields as necessary */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredTasks.map((taskuser, index) => (
                                                <tr
                                                    key={taskuser.id}>
                                                    <td className={`${selectedItems.includes(taskuser.id) ? "bg-primary text-white" : ""} 
                                                ${taskuser.ext_9 === 1 ? "light-color-sc" : ""} 
                                                ${annualIds.includes(taskuser.id) ? "" : ""}`} style={annualIds.includes(taskuser.id) ? { backgroundColor: "gray", color: "white" } : {}}>
                                                        <input type="checkbox" onChange={(e) => handleCheckboxChange(e, taskuser.id)} disabled={taskuser.ext_9 == 1 || taskuser.ext_6 > 0} />
                                                    </td>
                                                    <td className={`${selectedItems.includes(taskuser.id) ? "bg-primary text-white" : ""} 
                                                ${taskuser.ext_9 === 1 ? "light-color-sc" : ""} 
                                                ${annualIds.includes(taskuser.id) ? "" : ""}`} style={annualIds.includes(taskuser.id) ? { backgroundColor: "gray", color: "white" } : {}}>{index + 1}</td>
                                                    <td className={`${selectedItems.includes(taskuser.id) ? "bg-primary text-white" : ""} 
                                                ${taskuser.ext_9 === 1 ? "light-color-sc" : ""} 
                                                ${annualIds.includes(taskuser.id) ? "" : ""}`} style={annualIds.includes(taskuser.id) ? { backgroundColor: "gray", color: "white" } : {}}>{taskuser.fees_name ? taskuser.fees_name.name : ''}</td>

                                                    <td>{taskuser.fees_name ? taskuser.fees_name.ext_2 : ''}</td>
                                                    {/* <td>{taskuser.class ? taskuser.class : ''}</td>
                                                    <td>{taskuser.dev ? taskuser.dev : ''}</td> */}
                                                    <td>{taskuser.std_type ? taskuser.std_type : ''}</td>
                                                    <td>{taskuser.amount >= 0 ? taskuser.amount : ''}
                                                        {taskuser.amount >= 0 && taskuser.ext_6 > 0 &&
                                                            <a onClick={() => openEditModalUpdate(taskuser, index)} className="">
                                                                ✏️
                                                            </a>
                                                        }

                                                        {/* {taskuser.amount >= 0 && taskuser.ext_6 > 0 && taskuser.ext_10 == 1 &&
                                                            <a onClick={() => openEditModalUpdateOnce(taskuser, index)} className="">
                                                                ✏️
                                                            </a>
                                                        } */}

                                                        {taskuser.is_revised == 1 &&
                                                            <span className="round-icon">R</span>
                                                        }



                                                    </td>
                                                    <td className="text-success">
                                                        <b> {taskuser.ext_6}</b>
                                                    </td>
                                                    <td className="text-danger">
                                                        <b>{taskuser.amount - taskuser.ext_6}</b>
                                                    </td>
                                                    <td>
                                                        {taskuser.amount >= 0 ? moment(taskuser.ext_5).format("DD-MM-YYYY") : ''}

                                                    </td>
                                                    <td>
                                                        {taskuser.ext_6 ? (taskuser.ext_9 ? moment(taskuser.ext_9).format("DD-MM-YYYY") : moment(taskuser.updated_at).format("DD-MM-YYYY")) : null}

                                                    </td>
                                                    <td>
                                                        {taskuser.amount >= 0 && (
                                                            <>
                                                                <button
                                                                    className="btn btn-sm btn-link action_link"
                                                                    onClick={() => openEditModal(taskuser, index)}
                                                                >
                                                                    Pay
                                                                </button>
                                                                {taskuser.ext_6 > 0 && taskuser?.related_paid_fee_all?.length > 0 && (
                                                                    <button
                                                                        className="btn btn-sm btn-link action_link"
                                                                        onClick={() => openPaymentHistoryModal(taskuser)}
                                                                        title="View Payment History"
                                                                        style={{ padding: '0 5px' }}
                                                                    >
                                                                        📊
                                                                    </button>
                                                                )}
                                                                {/* {!taskuser?.ext_8 && taskuser?.related_paid_fee?.id && ( */}
                                                                {taskuser?.related_paid_fee_all?.map((fee) => (
                                                                    fee.fees_type === 1 ? (
                                                                        <Link
                                                                            key={fee.id}
                                                                            to={`/print/${fee.id}`}
                                                                            className="btn btn-sm btn-link action_link"
                                                                            target='_blank'
                                                                        >
                                                                            📙
                                                                        </Link>
                                                                    ) : null
                                                                ))}

                                                            </>
                                                        )}
                                                    </td>


                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                </>
                            )}
                            <button type="submit" onClick={() => openEditModalOnce()} className="btn btn-success button test_class">
                                Pay Once
                            </button>

                            {tasksAll
                                .filter(taskuser => taskuser.ext_1) // Filter tasks where ext_1 is not empty or null
                                .map((taskuser, index) => (
                                    <row key={taskuser.id}>
                                        <Link to={`/print_all/${taskuser.id}`} className="btn btn-sm btn-link action_link" target='_blank'>
                                            📙
                                        </Link>
                                    </row>
                                ))
                            }

                            {/* All Individual Paid Details with Invoice Numbers Table */}
                            {tasks && tasks.length > 0 && (
                                <>
                                    <div className="mt-5 mb-3 d-flex justify-content-between align-items-center">
                                        <h4 className="text-primary mb-0">
                                            <i className="fa fa-list-alt me-2"></i>
                                            All Payment Details with Invoice Numbers
                                        </h4>
                                        <button 
                                            className="btn btn-primary"
                                            onClick={() => setShowPaymentDetailsTable(!showPaymentDetailsTable)}
                                        >
                                            <i className={`fa fa-${showPaymentDetailsTable ? 'eye-slash' : 'eye'} me-2`}></i>
                                            {showPaymentDetailsTable ? 'Hide' : 'Show'} Details
                                        </button>
                                    </div>
                                    <hr />

                                    {showPaymentDetailsTable && (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped table-hover">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th style={{ width: '50px' }}>No.</th>
                                                    <th>Fee Name</th>
                                                    <th>Invoice No.</th>
                                                    <th>Amount Paid</th>
                                                    <th>Payment Date</th>
                                                    <th>Payment Mode</th>
                                                    <th>Reference No.</th>
                                                    <th>Received By</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tasks
                                                    .filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0)
                                                    .flatMap(task => 
                                                        task.related_paid_fee_all.map((payment, paymentIndex) => ({
                                                            ...payment,
                                                            feeName: task.fees_name ? task.fees_name.name : 'N/A'
                                                        }))
                                                    )
                                                    .sort((a, b) => {
                                                        const dateA = new Date(a.alt_date || a.created_at);
                                                        const dateB = new Date(b.alt_date || b.created_at);
                                                        return dateB - dateA; // Descending order (newest first)
                                                    })
                                                    .map((payment, index) => (
                                                        <tr key={`payment-${payment.id}`}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>
                                                                <span className="fw-bold">{payment.feeName}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                {payment.invoice ? (
                                                                    <span className="badge bg-primary" style={{ fontSize: '0.9em' }}>
                                                                        #{payment.invoice.invoice_id || 'N/A'}
                                                                    </span>
                                                                ) : payment.cinvoice ? (
                                                                    <span className="badge bg-info" style={{ fontSize: '0.9em' }}>
                                                                        #{payment.cinvoice.invoice_id || 'N/A'}
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-muted">-</span>
                                                                )}
                                                            </td>
                                                            <td className="text-end">
                                                                <span className="fw-bold text-success">
                                                                    ₹{parseFloat(payment.amount || 0).toLocaleString('en-IN', { 
                                                                        minimumFractionDigits: 2, 
                                                                        maximumFractionDigits: 2 
                                                                    })}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {payment.alt_date 
                                                                    ? moment(payment.alt_date).format("DD-MM-YYYY") 
                                                                    : moment(payment.created_at).format("DD-MM-YYYY")
                                                                }
                                                            </td>
                                                            <td>
                                                                {payment.ext_1 === 'Agent' && payment.agent_data ? (
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <span className="badge bg-warning">
                                                                            Mode
                                                                        </span>
                                                                        <span style={{ fontSize: '0.9em', color: '#2c3e50', fontWeight: '600' }}>
                                                                            {payment.agent_data.name}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                <span className={`badge ${
                                                                    payment.ext_1 === 'Cash' ? 'bg-success' : 
                                                                    payment.ext_1 === 'UPI' ? 'bg-info' : 
                                                                    'bg-secondary'
                                                                }`}>
                                                                    {payment.ext_1 || 'N/A'}
                                                                </span>
                                                                )}
                                                            </td>
                                                            <td>{payment.ext_2 || '-'}</td>
                                                            <td>
                                                                {(payment.user_name && payment.user_name.name) || '-'}
                                                            </td>
                                                            <td className="text-center">
                                                            {user.status === 1 && user.department_id === 1 && payment.fees_type === 1 &&
                                                                <button
                                                                    onClick={() => openEditPaymentModal(payment)}
                                                                    className="btn btn-sm btn-outline-warning me-2"
                                                                    title="Edit Payment"
                                                                >
                                                                    <i className="fa fa-edit me-1"></i>
                                                                    Edit
                                                                </button>
                                                                }
                                                                {payment.fees_type === 1 && (
                                                                    <Link
                                                                        to={`/print/${payment.id}`}
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        title="View Receipt"
                                                                        target='_blank'
                                                                    >
                                                                        <i className="fa fa-print me-1"></i>
                                                                        Print
                                                                    </Link>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                            <tfoot className="table-light">
                                                <tr>
                                                    <td colSpan="3" className="text-end fw-bold">Total Payments:</td>
                                                    <td className="text-end fw-bold text-success">
                                                        ₹{tasks
                                                            .filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0)
                                                            .flatMap(task => task.related_paid_fee_all)
                                                            .reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0)
                                                            .toLocaleString('en-IN', { 
                                                                minimumFractionDigits: 2, 
                                                                maximumFractionDigits: 2 
                                                            })
                                                        }
                                                    </td>
                                                    <td colSpan="5" className="text-muted">
                                                        <i className="fa fa-info-circle me-2"></i>
                                                        Total: {
                                                            tasks
                                                                .filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0)
                                                                .flatMap(task => task.related_paid_fee_all)
                                                                .length
                                                        } payment(s)
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    )}
                                </>
                            )}


                        </div>
                    </div>
                ) : (
                    <p>Loading...</p>
                )
            }

            {/* Payment History Modal */}
            {showPaymentHistoryModal && (
                <div className="modal" tabIndex="-1" style={{ display: "block", backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">
                                    <i className="fa fa-history me-2"></i>
                                    Payment History - {selectedFeeInfo.feeName}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={closePaymentHistoryModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <div className="card text-center">
                                            <div className="card-body">
                                                <h6 className="card-subtitle mb-2 text-muted">Total Amount</h6>
                                                <h4 className="card-title text-primary">
                                                    ₹{parseFloat(selectedFeeInfo.totalAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card text-center">
                                            <div className="card-body">
                                                <h6 className="card-subtitle mb-2 text-muted">Total Paid</h6>
                                                <h4 className="card-title text-success">
                                                    ₹{parseFloat(selectedFeeInfo.totalPaid || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card text-center">
                                            <div className="card-body">
                                                <h6 className="card-subtitle mb-2 text-muted">Total Due</h6>
                                                <h4 className="card-title text-danger">
                                                    ₹{parseFloat(selectedFeeInfo.totalDue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h6 className="mb-3">
                                    <i className="fa fa-list me-2"></i>
                                    Payment Details ({selectedPaymentHistory.length} installment{selectedPaymentHistory.length !== 1 ? 's' : ''})
                                </h6>

                                {selectedPaymentHistory.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped table-hover">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th style={{ width: '60px' }}>No.</th>
                                                    <th>Payment Date</th>
                                                    <th>Amount Paid</th>
                                                    <th>Payment Method</th>
                                                    <th>Reference No.</th>
                                                    <th>Received By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedPaymentHistory.map((payment, index) => (
                                                    <tr key={payment.id}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td>
                                                            {payment.alt_date 
                                                                ? moment(payment.alt_date).format("DD-MM-YYYY") 
                                                                : moment(payment.created_at).format("DD-MM-YYYY")
                                                            }
                                                        </td>
                                                        <td className="text-end fw-bold text-success">
                                                            ₹{parseFloat(payment.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td>
                                                            {payment.ext_1 === 'Agent' && payment.agent_data ? (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="badge bg-warning">
                                                                        Mode
                                                                    </span>
                                                                    <span style={{ fontSize: '0.9em', color: '#2c3e50', fontWeight: '600' }}>
                                                                        {payment.agent_data.name}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <span className={`badge ${
                                                                    payment.ext_1 === 'Cash' ? 'bg-success' : 
                                                                    payment.ext_1 === 'UPI' ? 'bg-info' : 
                                                                    'bg-secondary'
                                                                }`}>
                                                                {payment.ext_1 || 'N/A'}
                                                            </span>
                                                            )}
                                                        </td>
                                                        <td>{payment.ext_2 || '-'}</td>
                                                        <td>{(payment.user_name && payment.user_name.name) || '-'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="table-light">
                                                <tr>
                                                    <td colSpan="2" className="text-end fw-bold">Total Paid:</td>
                                                    <td className="text-end fw-bold text-success">
                                                        ₹{selectedPaymentHistory.reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </td>
                                                    <td colSpan="3"></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-info text-center">
                                        <i className="fa fa-info-circle me-2"></i>
                                        No payment history available for this fee.
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={closePaymentHistoryModal}
                                >
                                    <i className="fa fa-times me-2"></i>Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Individual Payment Modal */}
            {showEditPaymentModal && (
                <div className="modal" tabIndex="-1" style={{ display: "block", backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form onSubmit={submitEditPayment}>
                                <div className="modal-header bg-warning">
                                    <h5 className="modal-title">
                                        <i className="fa fa-edit me-2"></i>
                                        Edit Payment Details
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeEditPaymentModal}
                                        disabled={paymentInProgress}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {editingPayment && (
                                        <>
                                            <div className="alert alert-info">
                                                <strong>Fee:</strong> {editingPayment.feeName || 'N/A'}<br />
                                                <strong>Current Invoice:</strong> {
                                                    editingPayment.invoice?.invoice_id || 
                                                    editingPayment.cinvoice?.invoice_id || 
                                                    'N/A'
                                                }
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">
                                                    <strong>Amount Paid</strong> <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    name="amount"
                                                    className="form-control"
                                                    value={editPaymentData.amount}
                                                    onChange={handleEditPaymentChange}
                                                    placeholder="Enter amount"
                                                    min="0"
                                                    required
                                                />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">
                                                    <strong>Payment Method</strong> <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    name="ext_1"
                                                    className="form-control"
                                                    value={editPaymentData.ext_1}
                                                    onChange={handleEditPaymentChange}
                                                    required
                                                >
                                                    <option value="">Select Payment Method</option>
                                                    <option value="Cash">Cash</option>
                                                    <option value="UPI">UPI/Card</option>
                                                    <option value="Dbank">Dbank</option>
                                                    <option value="Cheque">Cheque</option>
                                                    <option value="Concession">Concession</option>
                                                    <option value="Agent">Agent</option>
                                                </select>
                                            </div>

                                            {editPaymentData.ext_1 === 'Agent' && (
                                                <div className="form-group mb-3">
                                                    <label className="form-label">
                                                        <strong>Select Agent</strong> <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        name="agent_id"
                                                        className="form-control"
                                                        value={editPaymentData.agent_id || ''}
                                                        onChange={handleEditPaymentChange}
                                                        required
                                                    >
                                                        <option value="">Select Agent</option>
                                                        {agent.map((agentItem) => (
                                                            <option key={agentItem.id} value={agentItem.id}>
                                                                {agentItem.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {editingPayment.agent_data && (
                                                        <small className="text-muted">
                                                            Current: {editingPayment.agent_data.name}
                                                        </small>
                                                    )}
                                                </div>
                                            )}

                                            <div className="form-group mb-3">
                                                <label className="form-label">
                                                    <strong>Reference No.</strong>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="ext_2"
                                                    className="form-control"
                                                    value={editPaymentData.ext_2}
                                                    onChange={handleEditPaymentChange}
                                                    placeholder="Enter reference number"
                                                />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">
                                                    <strong>Payment Date</strong> <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    name="alt_date"
                                                    className="form-control"
                                                    value={editPaymentData.alt_date}
                                                    onChange={handleEditPaymentChange}
                                                    max={moment().format('YYYY-MM-DD')}
                                                    required
                                                />
                                                <small className="text-muted">
                                                    Current: {moment(editPaymentData.alt_date).format("DD-MM-YYYY")}
                                                </small>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closeEditPaymentModal}
                                        disabled={paymentInProgress}
                                    >
                                        <i className="fa fa-times me-2"></i>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-warning"
                                        disabled={paymentInProgress}
                                    >
                                        <i className={`fa fa-${paymentInProgress ? 'spinner fa-spin' : 'save'} me-2`}></i>
                                        {paymentInProgress ? 'Updating...' : 'Update Payment'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Detailed Summary Modal */}
            {showDetailedSummaryModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {}}>
                                    <i className="fa fa-file-text me-2"></i>
                                    Detailed Fee Payment Summary - Print Preview
                                </h5>
                                <button type="button" className="btn-close" onClick={closeDetailedSummaryPreview}></button>
                            </div>
                            <div className="modal-body">
                                <div id="detailedSummaryPrintableArea">
                                    {students.map((student) => (
                                        <div key={student.id} className="mb-4">
                                            {/* Student Header Info */}
                                            <div className="text-center mb-4">
                                                {companylogo && (
                                                    <img 
                                                        src={getCompanyLogoUrl(companylogo)} 
                                                        alt="Company Logo" 
                                                        style={{ maxHeight: '80px', marginBottom: '10px' }}
                                                    />
                                                )}
                                                <h4 className="mb-1" style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {}}>{companyname}</h4>
                                                <p className="mb-1 small">{companyaddr}</p>
                                                <h5 className="mt-3 mb-3" style={user.company_id === 40 ? {fontFamily: 'Bookman Old Style', color: '#890015'} : {}}>
                                                    <strong>DETAILED FEE PAYMENT SUMMARY</strong>
                                                </h5>
                                            </div>

                                            {/* Student Details */}
                                            <div className="student-details-box mb-4 border p-4" style={{
                                                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                                borderRadius: '10px',
                                                border: '2px solid #3498db',
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                            }}>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="row mb-3">
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Name</span>
                                                                    <span className="detail-value">{student.ext_2} {student.ext_3 || ''}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Admission No</span>
                                                                    <span className="detail-value">{student.adm_no}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Class</span>
                                                                    <span className="detail-value">{student.class}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Division</span>
                                                                    <span className="detail-value">{student.section}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Phone</span>
                                                                    <span className="detail-value">{student.mobile || student.ext_1 || 'N/A'}</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-2">
                                                                <div className="detail-item">
                                                                    <span className="detail-label">Date</span>
                                                                    <span className="detail-value">{moment().format('DD-MM-YYYY')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 text-center">
                                                        {student.photo ? (
                                                            <img
                                                                src={getImageUrl(student.photo)}
                                                                alt="Student Photo"
                                                                style={{
                                                                    width: '135px',
                                                                    height: '145px',
                                                                    objectFit: 'cover',
                                                                    border: '2px solid #3498db',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                                }}
                                                            />
                                                        ) : (
                                                            <img 
                                                                src="/dummy.jpg" 
                                                                alt="Student Photo" 
                                                                style={{
                                                                    width: '135px',
                                                                    height: '145px',
                                                                    objectFit: 'cover',
                                                                    border: '2px solid #3498db',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <style>{`
                                                .detail-item {
                                                    display: flex;
                                                    flex-direction: column;
                                                }
                                                .detail-label {
                                                    font-size: 11px;
                                                    color: #7f8c8d;
                                                    font-weight: 600;
                                                    text-transform: uppercase;
                                                    letter-spacing: 0.5px;
                                                    margin-bottom: 4px;
                                                }
                                                .detail-value {
                                                    font-size: 15px;
                                                    color: #2c3e50;
                                                    font-weight: 700;
                                                }
                                            `}</style>

                                            {/* Detailed Fee-wise Payment Breakdown */}
                                            <div className="section-header mb-3" style={{
                                                background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                                                padding: '12px 16px',
                                                borderRadius: '8px',
                                                color: '#fff',
                                                boxShadow: '0 2px 4px rgba(52, 152, 219, 0.3)'
                                            }}>
                                                <h6 className="mb-0" style={{ color: '#fff', fontSize: '14px', fontWeight: '700' }}>
                                                    <i className="fa fa-list me-2"></i>
                                                    Fee-wise Payment Details
                                                </h6>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered" style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '13px', color: '#000' }}>
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th style={{ width: '30px' }}>No.</th>
                                                            <th>Fee Name</th>
                                                            <th className="text-end">Total Fee</th>
                                                            <th className="text-end">Paid</th>
                                                            <th className="text-end">Balance</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tasks && tasks.length > 0 ? (
                                                            tasks.map((task, index) => (
                                                                <tr key={task.id}>
                                                                    <td className="text-center">{index + 1}</td>
                                                                    <td>
                                                                        <strong>{task.fees_name ? task.fees_name.name : 'N/A'}</strong>
                                                                    </td>
                                                                    <td className="text-end" style={{ fontWeight: 700, fontSize: '14px' }}>
                                                                        ₹{parseFloat(task.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td className="text-end text-success" style={{ fontWeight: 700, fontSize: '14px' }}>
                                                                        <strong>₹{parseFloat(task.ext_6 || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                                                                    </td>
                                                                    <td className="text-end text-danger" style={{ fontWeight: 700, fontSize: '14px' }}>
                                                                        <strong>₹{parseFloat((task.amount || 0) - (task.ext_6 || 0)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                                                                    </td>
                                                                    <td>
                                                                        {((task.amount || 0) - (task.ext_6 || 0)) <= 0 ? (
                                                                            <span className="badge bg-success">Paid</span>
                                                                        ) : (task.ext_6 || 0) > 0 ? (
                                                                            <span className="badge bg-warning">Partial</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">Unpaid</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="text-center">No fee details available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Individual Payment Transactions */}
                                            {tasks && tasks.filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0).length > 0 && (
                                                <>
                                                    <div className="section-header mt-4 mb-3" style={{
                                                        background: 'linear-gradient(135deg, #27ae60 0%, #229954 100%)',
                                                        padding: '12px 16px',
                                                        borderRadius: '8px',
                                                        color: '#fff',
                                                        boxShadow: '0 2px 4px rgba(39, 174, 96, 0.3)'
                                                    }}>
                                                        <h6 className="mb-0" style={{ color: '#fff', fontSize: '14px', fontWeight: '700' }}>
                                                            <i className="fa fa-money me-2"></i>
                                                            Individual Payment Transactions
                                                        </h6>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped" style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '12px', color: '#000' }}>
                                                            <thead className="table-secondary">
                                                                <tr>
                                                                    <th style={{ width: '30px' }}>No.</th>
                                                                    <th>Date</th>
                                                                    <th>Fee Name</th>
                                                                    <th>Invoice No.</th>
                                                                    <th className="text-end">Amount</th>
                                                                    <th>Mode</th>
                                                                    <th>Ref. No.</th>
                                                                    <th>Received By</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tasks
                                                                    .filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0)
                                                                    .flatMap(task => 
                                                                        task.related_paid_fee_all.map((payment, paymentIndex) => ({
                                                                            ...payment,
                                                                            feeName: task.fees_name ? task.fees_name.name : 'N/A'
                                                                        }))
                                                                    )
                                                                    .sort((a, b) => {
                                                                        const dateA = new Date(a.alt_date || a.created_at);
                                                                        const dateB = new Date(b.alt_date || b.created_at);
                                                                        return dateB - dateA;
                                                                    })
                                                                    .map((payment, index) => (
                                                                        <tr key={`payment-${payment.id}`}>
                                                                            <td className="text-center">{index + 1}</td>
                                                                            <td>
                                                                                {payment.alt_date 
                                                                                    ? moment(payment.alt_date).format("DD-MM-YYYY") 
                                                                                    : moment(payment.created_at).format("DD-MM-YYYY")
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                <strong>{payment.feeName}</strong>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {payment.invoice ? (
                                                                                    <span className="badge bg-primary">
                                                                                        #{payment.invoice.invoice_id || 'N/A'}
                                                                                    </span>
                                                                                ) : payment.cinvoice ? (
                                                                                    <span className="badge bg-info">
                                                                                        #{payment.cinvoice.invoice_id || 'N/A'}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span>-</span>
                                                                                )}
                                                                            </td>
                                                                            <td className="text-end" style={{ fontWeight: 700, fontSize: '14px' }}>
                                                                                <strong className="text-success">
                                                                                    ₹{parseFloat(payment.amount || 0).toLocaleString('en-IN', { 
                                                                                        minimumFractionDigits: 2, 
                                                                                        maximumFractionDigits: 2 
                                                                                    })}
                                                                                </strong>
                                                                            </td>
                                                                            <td>
                                                                                {payment.ext_1 === 'Agent' && payment.agent_data ? (
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                                                                                        <span className="badge bg-warning" style={{ whiteSpace: 'nowrap' }}>
                                                                                            Mode
                                                                                        </span>
                                                                                        <span style={{ color: '#000', fontWeight: '700', whiteSpace: 'nowrap' }}>
                                                                                            {payment.agent_data.name}
                                                                                        </span>
                                                                                    </div>
                                                                                ) : (
                                                                                    <span className={`badge ${
                                                                                        payment.ext_1 === 'Cash' ? 'bg-success' : 
                                                                                        payment.ext_1 === 'UPI' ? 'bg-info' : 
                                                                                        'bg-secondary'
                                                                                    }`}>
                                                                                        {payment.ext_1 || 'N/A'}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td>{payment.ext_2 || '-'}</td>
                                                                            <td>
                                                                                {(payment.user_name && payment.user_name.name) || '-'}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                            <tfoot className="table-light">
                                                                <tr>
                                                                    <td colSpan="4" className="text-end"><strong>Total Payments:</strong></td>
                                                                    <td className="text-end">
                                                                        <strong className="text-success">
                                                                            ₹{parseFloat(
                                                                                tasks
                                                                                    .filter(task => task.related_paid_fee_all && task.related_paid_fee_all.length > 0)
                                                                                    .flatMap(task => task.related_paid_fee_all)
                                                                                    .reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0)
                                                                            ).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </strong>
                                                                    </td>
                                                                    <td colSpan="3"></td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </>
                                            )}

                                            {/* Footer */}
                                            <div className="mt-4 pt-3 border-top">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <p className="mb-1 small"><strong>Generated On:</strong> {moment().format('DD-MM-YYYY HH:mm:ss')}</p>
                                                        <p className="mb-0 small"><strong>Generated By:</strong> {user.name}</p>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                        <p className="mb-1 small">Authorized Signature</p>
                                                        <div style={{ borderTop: '1px solid #000', width: '150px', marginLeft: 'auto', marginTop: '30px' }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeDetailedSummaryPreview}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={printDetailedSummary}>
                                    <i className="fa fa-print me-2"></i>
                                    Print
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}